import { Tooltip } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import React from 'react';
import { getConfig } from '../../../../utils/config';

const swimmingPoolTitles = [
    'Swimming Pool',
    'Kids pool',
    'Lap Pool',
    'Swimming Pool with Jacuzzi',
    'Partially covered swimming pool',
    'Pool Deck with Cabanas',
    'Open to Sky Roof Top Swimming Pool',
    'Rooftop Infinity Swimming Pool',
    'Outdoor 50M Free Form Pool',
    'Covered Heated Pool',
    '2 Swimming Pool',
    'Clubhouse Swimming Pool',
    'Swimming pool and toddlers pool',
    'Picturesque Swimming Pool',
    'Pool Area',
    'Swimming Pool with sun decks',
    'changing room and locker room facility',
    'Swimming Pool with Pool Deck',
    'Children’s Pool',
    'Swimming Pool with Pool Deck',
    'Paddle Pool',
    'Kids’ Pool'
];
const gymTitles = [
    'Gym',
    'Fitness Center',
    '2 Level Gymnasium',
    'Indoor Gym',
    'Outdoor Gym',
    'Gymnasium',
    'Outdoor Fitness Area',
    'Fitness Center, Gymnasium',
    'Outdoor/Semi Open Gym Area',
    'A Well Equipped Health Club',
    'Fully equipped gymnasium',
    'Air-conditioned Gymnasium',
    'Modern Gymnasium',
    'Gymnasiums',
    'Open-Air Gym',
    'Gymnasium / Yoga Room',
    'Gymnasium with Fitness Centre and Steam',
    'Multi facility fitness centre'
];

const badmintonCourtTitles = [
    'Badminton Court',
    'Indoor Badminton Court',
    'Badminton Courts',
    'Outdoor Badminton Court',
    'Indoor-2 nos. Badminton Court',
    'Basements 1 and 2 - Badminton Courts - Double Height',
    '2 Badminton Courts',
    'Badminton courts'
];

const basketballCourtTitles = [
    'Basketball Court',
    'Half Basketball Court',
    'Indoor Basketball Court',
    'Basketball Dribbling Court',
    'Mini Basketball Court',
    'Outdoor Basketball/Tennis Multi-Court',
    'Half Basketball Court',
    'Basket Ball Court',
    'Half Basketball Court',
    'Basketball Practice'
];

const MeditationRoomTitles = [
    'Yoga',
    'Yoga Room Terrace',
    'Yoga Room',
    'Yoga Space',
    'Yoga Studio',
    'Yoga & Meditation Area',
    'Yoga & Meditation Zone',
    'Yoga Deck',
    'Yoga Lawn',
    'Suryanamaskar Zone',
    'Yoga/Meditation Deck',
    'Meditation Room',
    'Meditation Pavilion',
    'Yoga Room Multipurpose Hall',
    'Meditation Garden',
    'Yoga / Meditation Centre',
    'Meditation Room',
    'Outdoor Yoga',
    'Yoga Pavilion',
    'Yoga Area',
    'Meditation Area',
    'Yoga Court',
    'Yogazone'
];

const tennisCourtTitles = [
    'Tennis Court',
    'Outdoor Tennis Courts',
    'Lawn Tennis',
    'Tennis Court/Multi-purpose Court',
    'Lawn Tennis Court',
    'Outdoor Tennis Court',
    'Badminton/Tennis Multi-Court',
    '2 Tennis Court',
    'Tennis',
    'Padel Tennis Court',
    'Padel tennis courts'
];

const joggingTrackTitles = [
    'Jogging Track',
    'Jogging/Bicycle Track',
    'Jogging and Strolling Track',
    'Walking Track',
    'Walking Pathway',
    'Jogging & Walking Tracks',
    'Jogging Trail',
    'Outdoor Jogging Track',
    'Walking/Jogging Track',
    '300 M Rubberized Jogging Track',
    'Jogging Path',
    'Jogging Park',
    'Cycling and Jogging Track'
];

const spaTitles = [
    'Spa',
    'Salon & Spa',
    'Luxury Spa & Salon',
    'Spa and Wellness Center',
    'Spa Facilities',
    'Sundeck Spa',
    'Spa/Massage Room',
    'Spa and Sauna',
    'Wellness Center',
    'Steam Sauna',
    'Jacuzzi',
    'Steam, Sauna'
];

const skatingRingTitles = [
    'Skating Rink',
    'Skating Park',
    'Skating arena',
    'Skate Zone',
    'Outdoor Skate Park',
    'Skating Ring',
    'Skating Area',
    'Skating Track'
];
const cinemaTitles = [
    'Private Cinema',
    'Mini Theatre',
    'Terrace Cinema',
    'Screen Multiplex Terraces',
    '4 Screen Multiplex',
    'Theatre',
    'Miniplex-cum- Digital Gaming Zone',
    'Mini Movie Theater',
    'Family Entertainment Zone'
];
const resturantTitles = [
    'Gourmet Restaurant',
    'Outdoor Cafe',
    'Cafe Pantry',
    'Cafe',
    'Coffee Lounge and Restaurants',
    ' Rooftop Restaurant',
    'Multi Cuisine Restaurant',
    'Club House with Restaurant',
    'Cafes',
    'Food Outlets',
    'Fine dining'
];
const golfTitles = [
    'Golf Course',
    'Mini Golf',
    '9 Hole Golf Course',
    'Golf Putting Greens',
    'Golf Simulation',
    'Golf putting area',
    'Only Golf park of the region',
    'Golf Putting Greens'
];
const sportsTitles = [
    'Sports Facilities',
    'Multipurpose Games Hall',
    'Multipurpose Playground',
    'Multipurpose Court',
    'Multi-purpose Outdoor Court',
    'Sports Lawn',
    'Sports Arena',
    'World Class Sports Amenities',
    'Sports Facility',
    'Sports Complex',
    'Sports Bar',
    'Dedicated Sports Block',
    'Multi Sports Court'
];
const artTitles = [
    'Art Gallery',
    'Art Room',
    'Art and Culture',
    'Artists Corner'
];
const buisnessTitles = [
    'Business Center',
    'Conference Room',
    'Library And Business Centre',
    'Workstation Area',
    'Co-Working Space',
    'Club Amenities - Business Centre/Lounge',
    'Indoor-Co working Space / Business Center',
    'Business Center/WFH Cubicles',
    'Geek Zone: Co-working Space',
    'Co - Working Spaces & Business Pods'
];
const helipadTitles = ['Helipad '];
const ConciergeTitles = [
    'Concierge Services',
    'Reception And Lounge Space',
    '24x7 Concierge Services',
    'White Glove Services'
];
const SmartHomeTitles = [
    'Smart Home Technology',
    'Jio-Fiber Powered Automated Homes',
    'App for shared facility use',
    'Intelligent security with hi-tech sensors'
];
const PetSpaTitles = [
    'Pet Spa and Grooming Salon',
    'Pet Park With Pet Care Area',
    'Pets Park',
    "Pet's Park",
    'Pet Parks',
    'Outdoor Pet Park',
    'Dedicated Pet Park'
];
const skyLoungeTitles = [
    'Sky Lounge',
    'Lounge',
    'Lounge Bar',
    'Rooftop Deck for Lifestyle Cuisines',
    'Elevated Air Lounge',
    'Rooftop Party Area',
    'Terrace Lounge'
];
const LibraryTitles = [
    'Library and Reading Room',
    'Library/Reading Lounge',
    'Library',
    'Skylight Library',
    'Indoor-Library',
    'Library & Work Station',
    'Reading Room/Library',
    'Library / Study Area'
];
const MusicRoomTitles = [
    'Music Room',
    'Music Room',
    'Music/ Dance Studio',
    'Music Studio',
    'Art and Music Room',
    'Music Room',
    'Music and Dance Room'
];
const AmphitheaterTitles = [
    'Outdoor Amphitheater',
    'Amphitheatre',
    'Open-air Amphitheatre',
    'Terraced Garden Cum Amphitheatre',
    ' Outdoor Site Level Amphitheatre',

    'Open Air Theatre',
    'Amphi Theatre'
];
const MiniatureGolfCourseTitles = [
    'Miniature Golf Course',
    'Mini Golf',
    'Golf Putting Greens',
    'Mini Putt Golf'
];
const EquestrianTitles = ['Equestrian Facilities'];
const ObservatoryDeckTitles = [
    'Observatory Deck',
    'Panorama Viewing Deck',
    'Star Gazing Deck',
    'Star Observatory'
];
const ZenGardenTitles = [
    'Zen Garden',
    'Mist Garden',
    'Butterfly Valley',
    'Bamboo Forest',
    'Aroma Garden',
    'Wellness Center'
];
const OutdoorTitles = [
    'Outdoor Games',
    'Outdoor Play Area',
    'Multi Sports Court',
    'Children’s Play Area & Sand Pits',
    'Kids- Sand and Adventure Play Area'
];

const IndoorGamesTitles = [
    'Indoor Games',
    'Indoor Games Room',
    'Indoor Play Area',
    'Indoor Game Zone',
    'Table Tennis/Cards/Carrom',
    'Indoor-Board Games',
    'Indoor-Games Room',
    'Table Tennis',
    'Squash Court',
    '2 Squash Courts',
    'Indoor Squash Court',
    'Indoor-2 nos. Squash Courts',
    'Basements 1 and 2 - Squash Courts - Double Height',
    'Indoor Games Room',
    'Indoor Games',
    'Toddler’s Indoor Play Area'
];
const RockClimbingTitles = [
    'Rock Climbing Wall',
    'Climbing Wall',
    'Rock Climbing',
    'Rock Climbing Zone For Kids'
];
const bowlingTitles = ['Bowling Alley', 'Bowling'];
const soccerTitles = [
    'Soccer Field',
    'Mini Football Field',
    'Football Field',
    'Football Zone'
];
const CricketGroundTitles = [
    'Cricket Field',
    'Cricket Pitch',
    '2 Cricket Practice Nets',
    'Outdoor Cricket Ground',
    'Cricket Ground',
    'Cricket Net',
    'Outdoor Cricket Pitch',
    'Practice Cricket Net',
    'Net Cricket Truf',
    '2 Cricket Practice Net',
    'Cricket Turf',
    'Cricket pitch'
];
const ShootingTitles = ['Shooting Range '];
const SeatingAreas = [' Seating Areas'];
const KidsPlayArea = ["Kids' Play Area"];
const SeniorCitizenSeatingArea = ['Senior Citizen Seating Area'];
const BanquetHall = ['Banquet Hall'];
const infinityPoolTitles = [
    'Infinity Pool',
    'Infinity Swimming Pool',
    'Rooftop Infinity Swimming Pool',
    'Temperature Controlled Terrace Pool',
    'Infinity Edge Swimming Pool',
    'Infinity Edge'
];

const getAmenityIcon = (amenity) => {
    const normalizedTitle = amenity.toLowerCase().trim().replace(/\s+/g, ' ');
    switch (true) {
        case swimmingPoolTitles.some(
            (t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle
        ):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_9457"
                        data-name="Group 9457"
                        transform="translate(-25 -484)"
                    >
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 484)"
                            fill="#4d78eb"
                            opacity="0.1"
                        />
                        <g
                            id="swimming_pool_leisure"
                            data-name="swimming pool, leisure"
                            transform="translate(28 485.995)"
                        >
                            <path
                                id="Path_2095"
                                data-name="Path 2095"
                                d="M25.17,37.59a15.9,15.9,0,0,1-10.522.29,19.268,19.268,0,0,0-10.219-.306.547.547,0,1,0,.237,1.069,18.3,18.3,0,0,1,9.714.3,19.706,19.706,0,0,0,5.088.8,18.922,18.922,0,0,0,6.048-1.112.547.547,0,0,0-.346-1.038Z"
                                transform="translate(0 -14.044)"
                                fill="#4d78eb"
                            />
                            <path
                                id="Path_2096"
                                data-name="Path 2096"
                                d="M4.666,21.316a18.311,18.311,0,0,1,9.714.3,19.706,19.706,0,0,0,5.088.8A18.923,18.923,0,0,0,25.516,21.3a.547.547,0,0,0-.346-1.038A17.549,17.549,0,0,1,19.323,21.3V8.194a1.095,1.095,0,0,1,2.189,0,.547.547,0,1,0,1.095,0,2.189,2.189,0,0,0-4.378,0v2.189H10.567V8.194a1.095,1.095,0,1,1,2.189,0,.547.547,0,0,0,1.095,0,2.189,2.189,0,0,0-4.378,0v11.52a20.448,20.448,0,0,0-5.044.532.547.547,0,1,0,.237,1.069Zm5.9-6.554h7.662V16.95H10.567Zm7.662-3.284v2.189H10.567V11.478Zm-7.662,6.567h7.662v3.2a23.013,23.013,0,0,1-3.581-.689,25.62,25.62,0,0,0-4.081-.778Z"
                                transform="translate(0 0)"
                                fill="#4d78eb"
                            />
                        </g>
                    </g>
                </svg>
            );

        case infinityPoolTitles.some(
            (t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle
        ):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_11081"
                        data-name="Group 11081"
                        transform="translate(-25 -484)"
                    >
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 484)"
                            fill="#4d78eb"
                            opacity="0.1"
                        />
                        <g
                            id="swimming_pool_leisure"
                            data-name="swimming pool, leisure"
                            transform="translate(28 485.995)"
                        >
                            <path
                                id="Path_2095"
                                data-name="Path 2095"
                                d="M25.17,37.59a15.9,15.9,0,0,1-10.522.29,19.268,19.268,0,0,0-10.219-.306.547.547,0,1,0,.237,1.069,18.3,18.3,0,0,1,9.714.3,19.706,19.706,0,0,0,5.088.8,18.922,18.922,0,0,0,6.048-1.112.547.547,0,0,0-.346-1.038Z"
                                transform="translate(0 -14.044)"
                                fill="#4d78eb"
                            />
                            <path
                                id="Path_2096"
                                data-name="Path 2096"
                                d="M4.666,21.316a18.311,18.311,0,0,1,9.714.3,19.706,19.706,0,0,0,5.088.8A18.923,18.923,0,0,0,25.516,21.3a.547.547,0,0,0-.346-1.038A17.549,17.549,0,0,1,19.323,21.3V8.194a1.095,1.095,0,0,1,2.189,0,.547.547,0,1,0,1.095,0,2.189,2.189,0,0,0-4.378,0v2.189H10.567V8.194a1.095,1.095,0,1,1,2.189,0,.547.547,0,0,0,1.095,0,2.189,2.189,0,0,0-4.378,0v11.52a20.448,20.448,0,0,0-5.044.532.547.547,0,1,0,.237,1.069Zm5.9-6.554h7.662V16.95H10.567Zm7.662-3.284v2.189H10.567V11.478Zm-7.662,6.567h7.662v3.2a23.013,23.013,0,0,1-3.581-.689,25.62,25.62,0,0,0-4.081-.778Z"
                                transform="translate(0 0)"
                                fill="#4d78eb"
                            />
                        </g>
                    </g>
                </svg>
            );

        case gymTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_10416"
                        data-name="Group 10416"
                        transform="translate(-25 -792)"
                    >
                        <g
                            id="Group_889"
                            data-name="Group 889"
                            transform="translate(0 308)"
                        >
                            <circle
                                id="Ellipse_156"
                                data-name="Ellipse 156"
                                cx="18"
                                cy="18"
                                r="18"
                                transform="translate(25 484)"
                                fill="#e2a500"
                                opacity="0.1"
                            />
                        </g>
                        <g
                            id="home_workout"
                            data-name="home workout"
                            transform="translate(22.896 784.985)"
                        >
                            <g id="Group_10420" data-name="Group 10420">
                                <rect
                                    id="Rectangle_1851"
                                    data-name="Rectangle 1851"
                                    width="4"
                                    height="14"
                                    rx="2"
                                    transform="translate(12.104 18.015)"
                                    fill="none"
                                    stroke="#e2a500"
                                    stroke-linejoin="round"
                                    stroke-width="1.3"
                                />
                                <rect
                                    id="Rectangle_1852"
                                    data-name="Rectangle 1852"
                                    width="2"
                                    height="6"
                                    rx="1"
                                    transform="translate(10.104 22.015)"
                                    fill="none"
                                    stroke="#e2a500"
                                    stroke-linejoin="round"
                                    stroke-width="1"
                                />
                                <rect
                                    id="Rectangle_1854"
                                    data-name="Rectangle 1854"
                                    width="4"
                                    height="14"
                                    rx="2"
                                    transform="translate(28.104 32.015) rotate(180)"
                                    fill="none"
                                    stroke="#e2a500"
                                    stroke-linejoin="round"
                                    stroke-width="1.3"
                                />
                                <rect
                                    id="Rectangle_1855"
                                    data-name="Rectangle 1855"
                                    width="2"
                                    height="6"
                                    rx="1"
                                    transform="translate(30.104 28.015) rotate(180)"
                                    fill="none"
                                    stroke="#e2a500"
                                    stroke-linejoin="round"
                                    stroke-width="1"
                                />
                                <line
                                    id="Line_1276"
                                    data-name="Line 1276"
                                    x2="7.5"
                                    transform="translate(16.604 25.015)"
                                    fill="none"
                                    stroke="#e2a500"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                />
                            </g>
                        </g>
                    </g>
                </svg>
            );

        case spaTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_11083"
                        data-name="Group 11083"
                        transform="translate(-25 -741)"
                    >
                        <g id="Group_948" data-name="Group 948">
                            <circle
                                id="Ellipse_158"
                                data-name="Ellipse 158"
                                cx="18"
                                cy="18"
                                r="18"
                                transform="translate(25 741)"
                                fill="#edb600"
                                opacity="0.1"
                            />
                            <g
                                id="_751073_massage_spa_oil_relax_therapy_icon"
                                data-name="751073_massage_spa_oil_relax_therapy_icon"
                                transform="translate(30.446 749.999)"
                            >
                                <path
                                    id="Path_2099"
                                    data-name="Path 2099"
                                    d="M10.863,19.927H7.847A1.291,1.291,0,0,0,6.554,21.22v11.2h5.6V21.22A1.294,1.294,0,0,0,10.863,19.927Zm.4,11.667H7.44V22.057a1.009,1.009,0,0,1,.883-1.1h2.058a1.01,1.01,0,0,1,.883,1.1v9.537Z"
                                    transform="translate(0 -14.276)"
                                    fill="#edb600"
                                />
                                <path
                                    id="Path_2100"
                                    data-name="Path 2100"
                                    d="M13.084,4.846a1.374,1.374,0,0,0,1.229-1.384h.009s.085-1-1.755-3.46c.532,1.229-.378,1.928-.813,2.767a.112.112,0,0,0-.023.044c-.023.043-.045.087-.067.135a1.188,1.188,0,0,0-.05.137c0,.014-.006.028-.009.042a1.326,1.326,0,0,0-.039.492A1.378,1.378,0,0,0,13.084,4.846Zm-.756-1.722c0-.006.006-.013.008-.019a.519.519,0,0,1,.034-.062c.013-.022.028-.041.042-.06a.048.048,0,0,1,.014-.019c.268-.37.752-.639.585-1.264.7,1.307.592,1.778.592,1.778h0a.665.665,0,0,1-1.323-.121A.652.652,0,0,1,12.328,3.124Z"
                                    transform="translate(-3.586)"
                                    fill="#edb600"
                                />
                                <path
                                    id="Path_2101"
                                    data-name="Path 2101"
                                    d="M36.539,21.05a8.266,8.266,0,0,1-3.733,2.124c-.874.2-3.284,1.038-4.052,3.086a8.144,8.144,0,0,0,.739,6.968c-1.329-4.835.821-5.834,2.338-6.689.263-.145.5-.281.714-.413l-.024.018c-2.832,2.007-2.81,3.145-2.826,3.953-.011.573.192.568.447.423a31.329,31.329,0,0,0,3.285-1.481h0a6.541,6.541,0,0,0,1.489-1.079C37.023,25.794,36.539,21.05,36.539,21.05ZM34.1,27.6a3.88,3.88,0,0,1-.452.3,5.868,5.868,0,0,1-2.334.857c-.077-.016-.091-.147-.053-.322a5.578,5.578,0,0,1,1.214-1.5c.11-.094.221-.191.33-.291l0,0h0c.133-.12.261-.243.375-.364l.02-.018c.406-.384.453-.652.447-.778,0-.009,0-.018.005-.027a.17.17,0,0,0-.014-.039c0-.011-.006-.018-.006-.018h0c-.079-.145-.353-.15-.355-.15A8.317,8.317,0,0,0,29.8,27.131s-.005,0-.01.007c-.251.243-.337-.064-.343-.09a2.34,2.34,0,0,1,.451-1.013h0a.111.111,0,0,0,.012-.013c.023-.03.048-.06.073-.09h0a4.768,4.768,0,0,1,2.817-1.818h0a13.138,13.138,0,0,1,1.386-.469l.005,0c.339-.1,1.379-.367,1.379-.367h0c.1-.041.2-.054.19.088C35.7,24.139,35.426,26.542,34.1,27.6Z"
                                    transform="translate(-15.604 -15.081)"
                                    fill="#edb600"
                                />
                            </g>
                        </g>
                    </g>
                </svg>
            );

        case cinemaTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <circle
                        id="Ellipse_1752"
                        data-name="Ellipse 1752"
                        cx="18"
                        cy="18"
                        r="18"
                        fill="red"
                        opacity="0.1"
                    />
                    <g
                        id="_9042246_cinema_old_icon"
                        data-name="9042246_cinema_old_icon"
                        transform="translate(8 28.908) rotate(-90)"
                    >
                        <path
                            id="Path_7027"
                            data-name="Path 7027"
                            d="M6.691,13.382A1.691,1.691,0,1,0,5,11.691,1.691,1.691,0,0,0,6.691,13.382Z"
                            transform="translate(-0.464 -1.237)"
                            fill="none"
                            stroke="red"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.2"
                        />
                        <path
                            id="Path_7028"
                            data-name="Path 7028"
                            d="M16.691,13.382A1.691,1.691,0,1,0,15,11.691,1.691,1.691,0,0,0,16.691,13.382Z"
                            transform="translate(-2.01 -1.237)"
                            fill="none"
                            stroke="red"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.2"
                        />
                        <path
                            id="Path_7029"
                            data-name="Path 7029"
                            d="M11.691,8.382A1.691,1.691,0,1,0,10,6.691,1.691,1.691,0,0,0,11.691,8.382Z"
                            transform="translate(-1.237 -0.464)"
                            fill="none"
                            stroke="red"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.2"
                        />
                        <path
                            id="Path_7030"
                            data-name="Path 7030"
                            d="M11.691,18.382A1.691,1.691,0,1,0,10,16.691,1.691,1.691,0,0,0,11.691,18.382Z"
                            transform="translate(-1.237 -2.01)"
                            fill="none"
                            stroke="red"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.2"
                        />
                        <path
                            id="Path_7031"
                            data-name="Path 7031"
                            d="M2,10.454A8.454,8.454,0,1,0,10.454,2,8.454,8.454,0,0,0,2,10.454Zm0,0v8.454"
                            fill="none"
                            stroke="red"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.2"
                        />
                    </g>
                </svg>
            );

        case resturantTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <circle
                        id="Ellipse_1753"
                        data-name="Ellipse 1753"
                        cx="18"
                        cy="18"
                        r="18"
                        fill="#e2a500"
                        opacity="0.1"
                    />
                    <g
                        id="reshot-icon-restaurant-BE58FVGRA2"
                        transform="translate(13 -6.612)"
                    >
                        <g
                            id="Group_11093"
                            data-name="Group 11093"
                            transform="translate(0 15.354)"
                        >
                            <g id="Group_11091" data-name="Group 11091">
                                <path
                                    id="Path_7037"
                                    data-name="Path 7037"
                                    d="M2.339,37.009a1.311,1.311,0,0,1-1.3-1.317V25.377A2.246,2.246,0,0,1,0,23.469V18.4H.788v5.069a1.462,1.462,0,0,0,.817,1.325l.221.108v10.79a.512.512,0,1,0,1.024,0V24.808l.171-.118a1.479,1.479,0,0,0,.637-1.221V18.4h.788v5.069a2.271,2.271,0,0,1-.808,1.741V35.691A1.31,1.31,0,0,1,2.339,37.009Z"
                                    transform="translate(0 -18.4)"
                                    fill="#e2a500"
                                />
                            </g>
                            <g
                                id="Group_11092"
                                data-name="Group 11092"
                                transform="translate(1.829)"
                            >
                                <rect
                                    id="Rectangle_17142"
                                    data-name="Rectangle 17142"
                                    width="0.788"
                                    height="3.643"
                                    fill="#e2a500"
                                />
                            </g>
                        </g>
                        <g
                            id="Group_11096"
                            data-name="Group 11096"
                            transform="translate(7.795 14.612)"
                        >
                            <g
                                id="Group_11094"
                                data-name="Group 11094"
                                transform="translate(0)"
                            >
                                <path
                                    id="Path_7038"
                                    data-name="Path 7038"
                                    d="M114.466,33.963a1.286,1.286,0,0,1-1.3-1.268V26.623a19.567,19.567,0,0,1-.379-3.926c0-3.863.99-7.067,2.407-7.791l.574-.293V32.7A1.286,1.286,0,0,1,114.466,33.963Zm.513-17.8c-.757,1.086-1.4,3.483-1.4,6.535a18.7,18.7,0,0,0,.37,3.8l.009.082v6.114a.513.513,0,0,0,1.025,0Z"
                                    transform="translate(-112.787 -14.612)"
                                    fill="#e2a500"
                                />
                            </g>
                            <g
                                id="Group_11095"
                                data-name="Group 11095"
                                transform="translate(0.856 11.216)"
                            >
                                <rect
                                    id="Rectangle_17143"
                                    data-name="Rectangle 17143"
                                    width="2.076"
                                    height="0.788"
                                    fill="#e2a500"
                                />
                            </g>
                        </g>
                    </g>
                </svg>
            );

        case golfTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <circle
                        id="Ellipse_1754"
                        data-name="Ellipse 1754"
                        cx="18"
                        cy="18"
                        r="18"
                        fill="#cfdbd9"
                    />
                    <g id="golf-8" transform="translate(-245.829 -175.319)">
                        <path
                            id="Path_7040"
                            data-name="Path 7040"
                            d="M375.069,687.1a.626.626,0,0,1,.609-1.095,6.744,6.744,0,0,0,6.57-.02.626.626,0,0,1,.615,1.091,8,8,0,0,1-7.794.023Z"
                            transform="translate(-115.116 -486.247)"
                            fill="#009545"
                        />
                        <path
                            id="Path_7041"
                            data-name="Path 7041"
                            d="M258.292,197.686a7.83,7.83,0,1,1,11.073,0A7.83,7.83,0,0,1,258.292,197.686Zm.886-.886a6.577,6.577,0,1,0,0-9.3A6.577,6.577,0,0,0,259.178,196.8Z"
                            fill="#009545"
                        />
                        <path
                            id="Path_7042"
                            data-name="Path 7042"
                            d="M495.949,718.845a.626.626,0,0,1,1.253,0v2.417a.626.626,0,1,1-1.253,0Z"
                            transform="translate(-232.611 -517.569)"
                            fill="#009545"
                        />
                        <path
                            id="Path_7043"
                            data-name="Path 7043"
                            d="M569.416,287.816m-1.1,0a1.1,1.1,0,1,0,1.1-1.1A1.1,1.1,0,0,0,568.32,287.816Z"
                            transform="translate(-302.768 -99.269)"
                            fill="#009545"
                        />
                        <path
                            id="Path_7044"
                            data-name="Path 7044"
                            d="M477.256,298.056m-1.1,0a1.1,1.1,0,1,0,1.1-1.1A1.1,1.1,0,0,0,476.16,298.056Z"
                            transform="translate(-213.427 -109.196)"
                            fill="#009545"
                        />
                        <path
                            id="Path_7045"
                            data-name="Path 7045"
                            d="M630.856,359.5m-1.1,0a1.1,1.1,0,1,0,1.1-1.1A1.1,1.1,0,0,0,629.76,359.5Z"
                            transform="translate(-362.329 -168.757)"
                            fill="#009545"
                        />
                        <path
                            id="Path_7046"
                            data-name="Path 7046"
                            d="M543.816,369.736m-1.1,0a1.1,1.1,0,1,0,1.1-1.1A1.1,1.1,0,0,0,542.72,369.736Z"
                            transform="translate(-277.951 -178.683)"
                            fill="#009545"
                        />
                        <path
                            id="Path_7047"
                            data-name="Path 7047"
                            d="M615.5,441.416m-1.1,0a1.1,1.1,0,1,0,1.1-1.1A1.1,1.1,0,0,0,614.4,441.416Z"
                            transform="translate(-347.439 -248.171)"
                            fill="#009545"
                        />
                    </g>
                </svg>
            );

        case sportsTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <circle
                        id="Ellipse_1755"
                        data-name="Ellipse 1755"
                        cx="18"
                        cy="18"
                        r="18"
                        fill="#1cb0bd"
                        opacity="0.1"
                    />
                    <g
                        id="Group_11098"
                        data-name="Group 11098"
                        transform="translate(12336.261 -7923.62)"
                    >
                        <path
                            id="sports-10"
                            d="M100.431,93.983a9.326,9.326,0,0,0,.076-1.062,7.56,7.56,0,0,0-3.149-6.145c-.038-.038-.114-.114-.152-.114A7.586,7.586,0,0,0,85.333,92.92,7.5,7.5,0,0,0,87.04,97.7a7.557,7.557,0,0,0,13.353-3.642C100.431,94.02,100.431,94.02,100.431,93.983Zm-.683-1.062a4.123,4.123,0,0,1-.038.683,4.589,4.589,0,0,1-.721.038A6.688,6.688,0,0,1,96.107,93a9.812,9.812,0,0,0,1.366-5.007v-.114A6.714,6.714,0,0,1,99.749,92.92Zm-3.035-5.69v.759a8.89,8.89,0,0,1-1.29,4.666,6.92,6.92,0,0,1-3.262-5.842,4.123,4.123,0,0,1,.038-.683,4.593,4.593,0,0,1,.721-.038A6.868,6.868,0,0,1,96.714,87.23Zm-5.273-.986c0,.19-.038.379-.038.569a7.553,7.553,0,0,0,3.6,6.449,9.613,9.613,0,0,1-1.821,1.9,7.6,7.6,0,0,0-6.335-3.414,4.122,4.122,0,0,0-.683.038A6.947,6.947,0,0,1,91.441,86.244Zm-5.349,6.335a5.6,5.6,0,0,1,.8-.038,6.763,6.763,0,0,1,5.69,3.073,9.219,9.219,0,0,1-4.969,1.479H87.5a6.992,6.992,0,0,1-1.4-4.173Zm2.086,5.235a9.917,9.917,0,0,0,4.78-1.555,6.94,6.94,0,0,1,.759,3.073v.341a2.84,2.84,0,0,1-.8.076A6.647,6.647,0,0,1,88.178,97.814Zm6.259,1.745v-.228a7.364,7.364,0,0,0-.873-3.528,10.64,10.64,0,0,0,2.124-2.2,7.4,7.4,0,0,0,3.3.759,2.871,2.871,0,0,0,.569-.038A6.714,6.714,0,0,1,94.438,99.559Z"
                            transform="translate(-12411.594 7846.286)"
                            fill="#1cb0bd"
                            stroke="#1cb0bd"
                            stroke-width="0.3"
                        />
                        <g
                            id="Group_11097"
                            data-name="Group 11097"
                            transform="translate(-12322.756 7937.988)"
                        >
                            <circle
                                id="Ellipse_1756"
                                data-name="Ellipse 1756"
                                cx="5.327"
                                cy="5.327"
                                r="5.327"
                                transform="translate(1.539)"
                                fill="#cfe0e0"
                            />
                            <path
                                id="sports-152"
                                d="M43.477,41.653v.011a5.415,5.415,0,0,1-3.1,1.574.4.4,0,0,1-.063,0,.873.873,0,0,0-.221.032H40.08l-.074.011h-.032a3.246,3.246,0,0,1-.538,0,4.426,4.426,0,0,1-1.478-.169h-.021q-.1-.033-.2-.063a1.343,1.343,0,0,1-.38-.127,1.978,1.978,0,0,0-1.129-.021l.011-.01a2.374,2.374,0,0,0-.791.612l.021-.01q-.108.127-.8,1a.419.419,0,0,1-.19.137.4.4,0,0,1-.232.01.41.41,0,0,1-.2-.116l-1.454-1.458a.413.413,0,0,1-.116-.2.406.406,0,0,1,.011-.232.419.419,0,0,1,.137-.19q.836-.657,1.015-.781a2.341,2.341,0,0,0,.592-.771l-.011.011a1.987,1.987,0,0,0-.011-1.088,3.776,3.776,0,0,1-.211-.613v.011a5.868,5.868,0,0,1-.2-1.6,3.238,3.238,0,0,1,.042-.486,2.556,2.556,0,0,1,.021-.359,5.35,5.35,0,0,1,1.58-3.1,5.467,5.467,0,0,1,4.009-1.691,5.572,5.572,0,0,1,4.031,1.691,5.662,5.662,0,0,1,0,7.983Zm-8.462-.476L35,41.188a2.976,2.976,0,0,1-.823,1.109.625.625,0,0,1-.053.042q-.092.063-.612.475l.781.782.517-.654.021-.011a2.972,2.972,0,0,1,1.108-.824l.011-.01a2.691,2.691,0,0,1,1.709.042.589.589,0,0,1,.074.021.5.5,0,0,0,.148.042.469.469,0,0,1,.074.021l.254.085h-.022a3.535,3.535,0,0,0,.77.127l-4.3-4.31a4.824,4.824,0,0,0,.158.856v.01a3.1,3.1,0,0,0,.179.539.517.517,0,0,1,.032.074A2.748,2.748,0,0,1,35.015,41.178Zm7.871-6.916a4.744,4.744,0,0,0-3.44-1.437,4.671,4.671,0,0,0-3.418,1.437A4.561,4.561,0,0,0,34.7,36.9c0,.025-.008.049-.011.074L40.111,42.4c.045-.006.091-.009.137-.011a4.643,4.643,0,0,0,2.638-1.341v.011a4.847,4.847,0,0,0,0-6.8Zm-1.343,5.327a1.48,1.48,0,1,1,1.48-1.48A1.48,1.48,0,0,1,41.544,39.589Zm0-2.114a.634.634,0,1,0,.634.634A.634.634,0,0,0,41.544,37.475Z"
                                transform="translate(-32.46 -31.979)"
                                fill="#1cb0bd"
                            />
                        </g>
                    </g>
                </svg>
            );

        case artTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <circle
                        id="Ellipse_1757"
                        data-name="Ellipse 1757"
                        cx="18"
                        cy="18"
                        r="18"
                        fill="red"
                        opacity="0.1"
                    />
                    <g id="g61" transform="translate(8.837 94.17)">
                        <g id="g63" transform="translate(0 -85.333)">
                            <g id="g65" clip-path="url(#clip-path)">
                                <g id="g71" transform="translate(2.259 9.668)">
                                    <path
                                        id="path73"
                                        d="M-2.094-9.8v2.174a.976.976,0,0,0,.759.95Zm1.128,3.72H-1.12A1.548,1.548,0,0,1-2.667-7.621v-4.566a.286.286,0,0,1,.252-.284.287.287,0,0,1,.312.217L-.687-6.428a.287.287,0,0,1-.053.245.286.286,0,0,1-.225.109"
                                        transform="translate(2.667 12.474)"
                                        fill="red"
                                    />
                                </g>
                                <g id="g75" transform="translate(2.259 2.259)">
                                    <path
                                        id="path77"
                                        d="M-5.656-2.094a.976.976,0,0,0-.95.759l3.124-.759ZM-6.916-.679A.286.286,0,0,1-7.093-.74.287.287,0,0,1-7.2-.965V-1.12A1.548,1.548,0,0,1-5.656-2.667h4.566a.286.286,0,0,1,.284.252.287.287,0,0,1-.217.312L-6.849-.687a.285.285,0,0,1-.068.008"
                                        transform="translate(7.203 2.667)"
                                        fill="red"
                                    />
                                </g>
                                <g id="g79" transform="translate(14.08 2.259)">
                                    <path
                                        id="path81"
                                        d="M-2.4-2.182-1.641.942V-1.232a.976.976,0,0,0-.759-.95m1.045,5.8A.286.286,0,0,1-1.633,3.4L-3.048-2.425A.287.287,0,0,1-3-2.669a.287.287,0,0,1,.225-.109h.154A1.548,1.548,0,0,1-1.069-1.232V3.335a.286.286,0,0,1-.252.284l-.034,0"
                                        transform="translate(3.056 2.779)"
                                        fill="red"
                                    />
                                </g>
                                <g id="g83" transform="translate(9.668 14.08)">
                                    <path
                                        id="path85"
                                        d="M-9.8-5.173h2.174a.976.976,0,0,0,.95-.759Zm2.174.573h-4.566a.286.286,0,0,1-.284-.252.287.287,0,0,1,.217-.312L-6.429-6.58a.287.287,0,0,1,.245.053.286.286,0,0,1,.109.225v.154A1.548,1.548,0,0,1-7.622-4.6"
                                        transform="translate(12.475 6.588)"
                                        fill="red"
                                    />
                                </g>
                                <g id="g87" transform="translate(1.431 1.431)">
                                    <path
                                        id="path89"
                                        d="M-56.415-41.59l-1.08-4.432-1.415-5.827L-58.946-52a1.264,1.264,0,0,0-1.523-.928L-64.9-51.85l-5.827,1.415-.152.037a1.264,1.264,0,0,0-.928,1.524l1.08,4.432,1.415,5.827.037.152a1.264,1.264,0,0,0,1.523.928l4.433-1.08,5.827-1.415.152-.037A1.264,1.264,0,0,0-56.415-41.59Z"
                                        transform="translate(71.844 52.964)"
                                        fill="none"
                                        stroke="red"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-miterlimit="10"
                                        stroke-width="0.8"
                                    />
                                </g>
                                <g id="g91" transform="translate(5.521 7.684)">
                                    <path
                                        id="path93"
                                        d="M-30.347-17.016l-3.837-3.352a.222.222,0,0,0-.2-.049.224.224,0,0,0-.154.135l-1.871,4.738a.222.222,0,0,0,.039.228.223.223,0,0,0,.168.076.221.221,0,0,0,.052-.006l5.708-1.386a.222.222,0,0,0,.163-.163.222.222,0,0,0-.07-.22"
                                        transform="translate(36.423 20.423)"
                                        fill="red"
                                    />
                                </g>
                                <g id="g95" transform="translate(9.698 8.18)">
                                    <path
                                        id="path97"
                                        d="M-20.158-11.917l-2.834-2.336a.223.223,0,0,0-.183-.047.223.223,0,0,0-.153.111l-.839,1.519a.222.222,0,0,0,.048.275l1.53,1.337a.222.222,0,0,0,.146.055.223.223,0,0,0,.052-.006l2.142-.521a.222.222,0,0,0,.164-.166.222.222,0,0,0-.075-.221"
                                        transform="translate(24.195 14.304)"
                                        fill="red"
                                    />
                                </g>
                                <g id="g99" transform="translate(8.642 6.48)">
                                    <path
                                        id="path101"
                                        d="M-6.665-3.333a.667.667,0,0,1-.667.667A.667.667,0,0,1-8-3.333.667.667,0,0,1-7.333-4a.667.667,0,0,1,.667.667"
                                        transform="translate(8 4)"
                                        fill="red"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            );
        case buisnessTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_11099"
                        data-name="Group 11099"
                        transform="translate(-25 -484)"
                    >
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 484)"
                            fill="#e2a500"
                            opacity="0.1"
                        />
                    </g>
                    <g
                        id="partner-handshake-icon"
                        transform="translate(8.011 12.005)"
                    >
                        <path
                            id="Path_7048"
                            data-name="Path 7048"
                            d="M16.16,2.337a.264.264,0,0,1-.028.091,1.027,1.027,0,0,0-.025.236c0,.008,0,.017,0,.025V8.43a.949.949,0,0,0,.269.4.533.533,0,0,0,.37.111.2.2,0,0,1,.031,0h1.659A.659.659,0,0,0,19,8.74a1.337,1.337,0,0,0,.25-.77h0v0l.5-5.178a.125.125,0,0,1,0-.025.609.609,0,0,0-.175-.6,1.344,1.344,0,0,0-.8-.182l-.025,0H16.9v0a.909.909,0,0,0-.618.172.483.483,0,0,0-.122.183Zm-1.814,6.35a.277.277,0,0,1-.079-.142L11.622,3.787c-.294-.491-.558-.5-.815-.35a3.8,3.8,0,0,0-.565.458c-.116.106-.231.212-.329.292l-.454.375h0l0,0A1.949,1.949,0,0,1,8.4,5a1.5,1.5,0,0,1-.663-.088,1.235,1.235,0,0,1-.534-.38,1.276,1.276,0,0,1-.273-.706h0a.268.268,0,0,1,.061-.192L8.436,1.918a2.576,2.576,0,0,0-.826.116,4.329,4.329,0,0,0-1.138.6.268.268,0,0,1-.164.056H4.644V5.832l.007,2.011h.968a.262.262,0,0,1,.23.134l1.2,2.1a3.028,3.028,0,0,0,.524.744,1.148,1.148,0,0,0,.787.274.961.961,0,0,0,.393-.071,1.084,1.084,0,0,0,.226-.129L8.2,9.434a.264.264,0,1,1,.466-.248l.848,1.585a1.291,1.291,0,0,0,.858.155,1.283,1.283,0,0,0,.664-.42L9.816,8.59a.264.264,0,0,1,.446-.284l1.286,2.019a.993.993,0,0,0,.649.056A1.332,1.332,0,0,0,12.789,10L11.624,7.8a.265.265,0,0,1,.469-.248L13.3,9.824a.771.771,0,0,0,.512.086.935.935,0,0,0,.42-.185.74.74,0,0,0,.25-.347.718.718,0,0,0-.035-.506l-.1-.185Zm.35-.459h.882V2.689a.094.094,0,0,1,0-.021,1.679,1.679,0,0,1,.017-.246l-.9-.6-.015-.01c-.117-.078-.258-.177-.4-.276a5.328,5.328,0,0,0-1.6-.874,4.364,4.364,0,0,0-1.02-.14,3.437,3.437,0,0,0-.939.1,2.353,2.353,0,0,0-.517.2,1.8,1.8,0,0,0-.4.281l-.6.715a.27.27,0,0,1-.076.091L7.475,3.887a.736.736,0,0,0,.142.317.724.724,0,0,0,.306.216,1,1,0,0,0,.433.053,1.432,1.432,0,0,0,.767-.321h0l.454-.375c.116-.1.213-.185.311-.273a4.224,4.224,0,0,1,.649-.522c.517-.309,1.033-.319,1.542.535l0,.008,2.612,4.7Zm.982.53h-.706a1.211,1.211,0,0,1,.015.778,1.27,1.27,0,0,1-.425.6,1.457,1.457,0,0,1-.664.294,1.3,1.3,0,0,1-.715-.078,1.866,1.866,0,0,1-.844.537,1.479,1.479,0,0,1-.9-.041,1.79,1.79,0,0,1-.955.593,1.756,1.756,0,0,1-1.137-.165,1.681,1.681,0,0,1-.393.231,1.444,1.444,0,0,1-.61.111,1.65,1.65,0,0,1-1.124-.41,3.37,3.37,0,0,1-.633-.874L5.464,8.373H4.591a1.532,1.532,0,0,1-.271.639,1.152,1.152,0,0,1-1,.43H1.809a.969.969,0,0,1-.952-.324,2.355,2.355,0,0,1-.443-1.3c0-.007,0-.015,0-.023L.018,2.922a1.408,1.408,0,0,1,.22-1.152,1.222,1.222,0,0,1,.93-.39.221.221,0,0,1,.033,0H3.215v0a1.707,1.707,0,0,1,.955.22.967.967,0,0,1,.416.558H6.227a4.74,4.74,0,0,1,1.224-.63,3.277,3.277,0,0,1,1.4-.112L9.41.763A.227.227,0,0,1,9.443.726a2.332,2.332,0,0,1,.52-.37,2.966,2.966,0,0,1,.631-.241A4.027,4.027,0,0,1,11.673,0,5.018,5.018,0,0,1,12.82.153a5.735,5.735,0,0,1,1.768.953c.122.086.245.172.39.268l.015.01.8.532a.872.872,0,0,1,.139-.154,1.409,1.409,0,0,1,.973-.306v0h1.854a.094.094,0,0,1,.021,0,1.82,1.82,0,0,1,1.129.291,1.1,1.1,0,0,1,.378,1.079s0,.008,0,.013l-.5,5.174h0A1.825,1.825,0,0,1,19.4,9.089a1.156,1.156,0,0,1-.978.382H16.777a1.045,1.045,0,0,1-.73-.225,1.375,1.375,0,0,1-.37-.487ZM2.3,6.748a.359.359,0,1,1-.359.359A.358.358,0,0,1,2.3,6.748Zm15.607,0a.359.359,0,1,1-.359.359.358.358,0,0,1,.359-.359ZM4.114,5.221l-.01-2.8V2.407a.5.5,0,0,0-.216-.365,1.23,1.23,0,0,0-.666-.134h0v0H1.192a.731.731,0,0,0-.547.2.94.94,0,0,0-.1.744.109.109,0,0,1,0,.023L.94,7.756v.008a1.88,1.88,0,0,0,.316,1.008.485.485,0,0,0,.489.145.22.22,0,0,1,.046,0v0H3.3a.151.151,0,0,1,.028,0A.653.653,0,0,0,3.9,8.687a1.387,1.387,0,0,0,.212-.8h0V5.221Zm7.969-1.7Z"
                            transform="translate(0 0)"
                            fill="#e2a500"
                            stroke="#e2a500"
                            stroke-width="0.3"
                        />
                    </g>
                </svg>
            );

        case helipadTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_11100"
                        data-name="Group 11100"
                        transform="translate(-25 -484)"
                    >
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 484)"
                            fill="#16519e"
                            opacity="0.1"
                        />
                    </g>
                    <g
                        id="_9044796_navaid_helipad_icon"
                        data-name="9044796_navaid_helipad_icon"
                        transform="translate(7 7.489)"
                    >
                        <path
                            id="Path_7049"
                            data-name="Path 7049"
                            d="M16.033,9v4.033H13.344V9H12v9.411h1.344V14.378h2.689v4.033h1.344V9Z"
                            transform="translate(-3.933 -2.95)"
                            fill="#16519e"
                        />
                        <path
                            id="Path_7050"
                            data-name="Path 7050"
                            d="M11.411,20.822a9.411,9.411,0,1,1,9.411-9.411A9.411,9.411,0,0,1,11.411,20.822Zm0-17.477a8.067,8.067,0,1,0,8.067,8.067,8.067,8.067,0,0,0-8.067-8.067Z"
                            transform="translate(-0.656 -0.656)"
                            fill="#16519e"
                        />
                        <rect
                            id="_Transparent_Rectangle_"
                            data-name="&lt;Transparent Rectangle&gt;"
                            width="22"
                            height="22"
                            transform="translate(22 21.511) rotate(180)"
                            fill="none"
                        />
                    </g>
                </svg>
            );

        case ConciergeTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_11101"
                        data-name="Group 11101"
                        transform="translate(-25 -484)"
                    >
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 484)"
                            fill="#16519e"
                            opacity="0.1"
                        />
                    </g>
                    <g id="phone-138" transform="translate(4.478 -98.493)">
                        <path
                            id="Path_7097"
                            data-name="Path 7097"
                            d="M20.784,115.057a6.351,6.351,0,0,1-3.4-.933,2.023,2.023,0,0,1-.5-1.14c-.082-.434-.132-.563-.322-.645a9.155,9.155,0,0,0-3.439-.591,9.111,9.111,0,0,0-3.4.581c-.188.08-.236.209-.317.642a2.018,2.018,0,0,1-.5,1.142,3.577,3.577,0,0,1-1.485.663,8.163,8.163,0,0,1-1.9.259,1.839,1.839,0,0,1-1.329-.374,2.308,2.308,0,0,1-.663-1.421,2.115,2.115,0,0,1,.659-1.706,9.782,9.782,0,0,1,3.957-2.293,16.2,16.2,0,0,1,4.952-.749,16.3,16.3,0,0,1,4.993.757,9.893,9.893,0,0,1,3.994,2.317,2.16,2.16,0,0,1,.012,3.119A1.817,1.817,0,0,1,20.784,115.057ZM13.12,110.78a10.021,10.021,0,0,1,3.821.669,1.586,1.586,0,0,1,.891,1.354,1.216,1.216,0,0,0,.232.635,5.925,5.925,0,0,0,2.72.65,1.341,1.341,0,0,0,.631-.091,1.191,1.191,0,0,0-.016-1.745c-1.748-1.748-4.852-2.791-8.3-2.791-3.423,0-6.5,1.031-8.225,2.758a1.167,1.167,0,0,0-.379.943,1.343,1.343,0,0,0,.378.81,1.354,1.354,0,0,0,.649.095,5.909,5.909,0,0,0,2.7-.638,1.21,1.21,0,0,0,.229-.633,1.578,1.578,0,0,1,.888-1.356,9.939,9.939,0,0,1,3.782-.659Z"
                            fill="#16519e"
                            stroke="#16519e"
                            stroke-width="0.3"
                        />
                        <path
                            id="Path_7098"
                            data-name="Path 7098"
                            d="M71.642,419.284H59.052a2.3,2.3,0,0,1-2.313-2.445,8.349,8.349,0,0,1,1.23-3.621,7.262,7.262,0,0,1,2.6-2.5,10.724,10.724,0,0,1,9.552,0,7.247,7.247,0,0,1,2.6,2.5,8.356,8.356,0,0,1,1.23,3.621,2.3,2.3,0,0,1-2.313,2.445Zm-6.295-8.716c-3.019,0-5.218,1.054-6.536,3.131a7.5,7.5,0,0,0-1.1,3.195,1.332,1.332,0,0,0,1.346,1.422H71.643a1.332,1.332,0,0,0,1.346-1.423,7.514,7.514,0,0,0-1.1-3.194c-1.319-2.077-3.518-3.131-6.536-3.131Z"
                            transform="translate(-52.207 -295.412)"
                            fill="#16519e"
                            stroke="#16519e"
                            stroke-width="0.3"
                        />
                        <path
                            id="Path_7099"
                            data-name="Path 7099"
                            d="M361.305,517.81a2.905,2.905,0,1,1,2.905-2.905A2.909,2.909,0,0,1,361.305,517.81Zm0-4.842a1.937,1.937,0,1,0,1.937,1.937A1.939,1.939,0,0,0,361.305,512.968Z"
                            transform="translate(-348.165 -395.875)"
                            fill="#16519e"
                            stroke="#16519e"
                            stroke-width="0.3"
                        />
                    </g>
                </svg>
            );

        case SmartHomeTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_11102"
                        data-name="Group 11102"
                        transform="translate(-25 -484)"
                    >
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 484)"
                            fill="red"
                            opacity="0.1"
                        />
                    </g>
                    <g
                        id="_9698473_smart_home_icon"
                        data-name="9698473_smart_home_icon"
                        transform="translate(9 8.575)"
                    >
                        <path
                            id="Path_7051"
                            data-name="Path 7051"
                            d="M12.808,16.366H8.425a.53.53,0,1,1,0-1.06h4.383a1.732,1.732,0,0,0,1.626-1.379l.94-5.627a1.883,1.883,0,0,0-.594-1.555l-4.9-3.916a1.75,1.75,0,0,0-2.064-.007l-4.9,3.924A1.87,1.87,0,0,0,2.324,8.3l.2,1.195a.53.53,0,1,1-1.046.17l-.2-1.188a2.93,2.93,0,0,1,.976-2.559l4.9-3.924A2.8,2.8,0,0,1,10.546,2l4.9,3.917a2.968,2.968,0,0,1,.976,2.559L15.48,14.1A2.805,2.805,0,0,1,12.808,16.366Z"
                            transform="translate(-0.073)"
                            fill="red"
                        />
                        <path
                            id="Path_7052"
                            data-name="Path 7052"
                            d="M3.9,21.431a.531.531,0,0,1-.53-.516,1.548,1.548,0,0,0-1.6-1.6.53.53,0,0,1,.014-1.06h.014a2.6,2.6,0,0,1,2.637,2.637.534.534,0,0,1-.516.544Z"
                            transform="translate(-0.073 -4.93)"
                            fill="red"
                        />
                        <path
                            id="Path_7053"
                            data-name="Path 7053"
                            d="M6.022,20.552a.528.528,0,0,1-.53-.523A4.331,4.331,0,0,0,5.266,18.7,3.479,3.479,0,0,0,3.1,16.537a3.946,3.946,0,0,0-1.329-.226.53.53,0,0,1,.007-1.06h.007a5.2,5.2,0,0,1,1.668.29,4.534,4.534,0,0,1,2.807,2.807,5.234,5.234,0,0,1,.29,1.668.531.531,0,0,1-.53.537Z"
                            transform="translate(-0.073 -4.051)"
                            fill="red"
                        />
                        <path
                            id="Path_7054"
                            data-name="Path 7054"
                            d="M1.707,22.414a.707.707,0,1,1,.707-.707A.7.7,0,0,1,1.707,22.414Z"
                            transform="translate(0 -5.736)"
                            fill="red"
                        />
                    </g>
                </svg>
            );

        case PetSpaTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_11103"
                        data-name="Group 11103"
                        transform="translate(-25 -484)"
                    >
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 484)"
                            fill="#e2a500"
                            opacity="0.1"
                        />
                    </g>
                    <g
                        id="_9024515_dog_light_icon"
                        data-name="9024515_dog_light_icon"
                        transform="translate(-12.854 -23.857)"
                    >
                        <line
                            id="Line_1314"
                            data-name="Line 1314"
                            y2="2.15"
                            transform="translate(30.518 46.819)"
                            fill="none"
                            stroke="#e2a500"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.2"
                        />
                        <circle
                            id="Ellipse_1758"
                            data-name="Ellipse 1758"
                            cx="0.86"
                            cy="0.86"
                            r="0.86"
                            transform="translate(26.647 41.659)"
                            fill="#e2a500"
                        />
                        <circle
                            id="Ellipse_1759"
                            data-name="Ellipse 1759"
                            cx="0.86"
                            cy="0.86"
                            r="0.86"
                            transform="translate(32.668 41.659)"
                            fill="#e2a500"
                        />
                        <path
                            id="Path_7055"
                            data-name="Path 7055"
                            d="M114.656,176l-1.328,1.328L112,176"
                            transform="translate(-82.664 -130.346)"
                            fill="none"
                            stroke="#e2a500"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.2"
                        />
                        <path
                            id="Path_7056"
                            data-name="Path 7056"
                            d="M152,35.032l4.631-1.154a.664.664,0,0,1,.813.515l1.361,7.27a.666.666,0,0,1-1.178.531Z"
                            transform="translate(-119.345)"
                            fill="none"
                            stroke="#e2a500"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.2"
                        />
                        <path
                            id="Path_7057"
                            data-name="Path 7057"
                            d="M28.672,35.032l-4.631-1.154a.664.664,0,0,0-.813.515l-1.361,7.27a.666.666,0,0,0,1.178.531Z"
                            transform="translate(0)"
                            fill="none"
                            stroke="#e2a500"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.2"
                        />
                        <line
                            id="Line_1315"
                            data-name="Line 1315"
                            x2="3.87"
                            transform="translate(28.797 35.209)"
                            fill="none"
                            stroke="#e2a500"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.2"
                        />
                        <path
                            id="Path_7058"
                            data-name="Path 7058"
                            d="M61.278,119.3v5.369a2.656,2.656,0,0,1-2.656,2.656H50.656A2.656,2.656,0,0,1,48,124.669V119.3"
                            transform="translate(-23.975 -78.351)"
                            fill="none"
                            stroke="#e2a500"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.2"
                        />
                    </g>
                </svg>
            );

        case skyLoungeTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_11104"
                        data-name="Group 11104"
                        transform="translate(-25 -484)"
                    >
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 484)"
                            fill="#009545"
                            opacity="0.1"
                        />
                    </g>
                    <g
                        id="_9044796_navaid_helipad_icon"
                        data-name="9044796_navaid_helipad_icon"
                        transform="translate(7 7.489)"
                    >
                        <path
                            id="Path_7049"
                            data-name="Path 7049"
                            d="M16.033,9v4.033H13.344V9H12v9.411h1.344V14.378h2.689v4.033h1.344V9Z"
                            transform="translate(-3.933 -2.95)"
                            fill="#009545"
                        />
                        <path
                            id="Path_7050"
                            data-name="Path 7050"
                            d="M11.411,20.822a9.411,9.411,0,1,1,9.411-9.411A9.411,9.411,0,0,1,11.411,20.822Zm0-17.477a8.067,8.067,0,1,0,8.067,8.067,8.067,8.067,0,0,0-8.067-8.067Z"
                            transform="translate(-0.656 -0.656)"
                            fill="#009545"
                        />
                        <rect
                            id="_Transparent_Rectangle_"
                            data-name="&lt;Transparent Rectangle&gt;"
                            width="22"
                            height="22"
                            transform="translate(22 21.511) rotate(180)"
                            fill="none"
                        />
                    </g>
                </svg>
            );

        case LibraryTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <circle
                        id="Ellipse_1760"
                        data-name="Ellipse 1760"
                        cx="18"
                        cy="18"
                        r="18"
                        fill="#1cb0bd"
                        opacity="0.1"
                    />
                    <path
                        id="_8922077_library_book_education_language_icon"
                        data-name="8922077_library_book_education_language_icon"
                        d="M17.637,6.532v4.331H14.4V6.532a.459.459,0,0,0-.459-.459H10a.459.459,0,0,0-.459.459V8.978H5.959a.459.459,0,0,0-.459.459V21.678a.459.459,0,0,0,.459.459H22.033a.459.459,0,0,0,.459-.459V6.532a.459.459,0,0,0-.459-.459H18.1a.459.459,0,0,0-.459.459Zm-7.282.35h3.236v.839H10.355ZM9.546,21.328H6.309v-.792H9.546Zm0-1.6H6.309V11.3H9.546Zm0-9.232H6.309V9.787H9.546Zm4.046,10.833H10.355v-.792h3.236Zm0-1.6H10.355V8.53h3.236v11.2Zm4.046,1.6H14.4v-.792h3.236Zm0-1.6H14.4V13.168h3.236Zm0-7.368H14.4v-.687h3.236Zm4.046,8.969H18.446v-.792h3.236Zm0-1.6H18.446V8.53h3.236Zm0-12.006H18.446V6.882h3.236Z"
                        transform="translate(3.679 3.895)"
                        fill="#1cb0bd"
                    />
                </svg>
            );

        case MusicRoomTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_11105"
                        data-name="Group 11105"
                        transform="translate(-25 -484)"
                    >
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 484)"
                            fill="#16519e"
                            opacity="0.1"
                        />
                    </g>
                    <path
                        id="_9057204_music_icon"
                        data-name="9057204_music_icon"
                        d="M15.51,4.7A2.7,2.7,0,0,0,12.4,2.032l-4.728.727A2.7,2.7,0,0,0,5.377,5.43v5.919a2.365,2.365,0,1,0,1.351,2.137V5.43A1.351,1.351,0,0,1,7.874,4.095L12.6,3.367A1.351,1.351,0,0,1,14.159,4.7v4.62A2.365,2.365,0,1,0,15.51,11.46Zm-1.351,6.757a1.013,1.013,0,1,0-1.013,1.013A1.013,1.013,0,0,0,14.159,11.459ZM5.377,13.486A1.013,1.013,0,1,0,4.364,14.5,1.013,1.013,0,0,0,5.377,13.486Z"
                        transform="translate(9 9)"
                        fill="#16519e"
                        fill-rule="evenodd"
                    />
                </svg>
            );

        case AmphitheaterTitles.some(
            (t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle
        ):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_11106"
                        data-name="Group 11106"
                        transform="translate(-25 -484)"
                    >
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 484)"
                            fill="red"
                            opacity="0.1"
                        />
                    </g>
                    <g
                        id="Group_11107"
                        data-name="Group 11107"
                        transform="translate(12304 -8444.723)"
                    >
                        <g
                            id="Path_7059"
                            data-name="Path 7059"
                            transform="translate(-12293 8456.688)"
                            fill="none"
                        >
                            <path
                                d="M.844-1h0c.466,0,.832.841.844.844L6.752,10.815a.844.844,0,0,1-.844.844H.844A.844.844,0,0,1,0,10.815V-.156A.844.844,0,0,1,.844-1Z"
                                stroke="none"
                            />
                            <path
                                d="M 0.7766447067260742 -0.2832756042480469 C 0.7310919761657715 -0.2590789794921875 0.7000012397766113 -0.211125373840332 0.7000012397766113 -0.1560497283935547 L 0.7000012397766113 10.81522941589355 C 0.7000012397766113 10.89459991455078 0.7645711898803711 10.95917987823486 0.8439412117004395 10.95917987823486 L 5.907621383666992 10.95917987823486 C 5.953787803649902 10.95917987823486 5.994951248168945 10.93732452392578 6.021308898925781 10.90342426300049 L 1.065621376037598 0.166107177734375 C 1.056941509246826 0.1505060195922852 1.049793243408203 0.1367216110229492 1.04392147064209 0.1253995895385742 C 0.9198369979858398 -0.1138906478881836 0.8284053802490234 -0.2297048568725586 0.7766447067260742 -0.2832756042480469 M 0.8439412117004395 -1 C 1.310041427612305 -1 1.675531387329102 -0.1593704223632812 1.687891483306885 -0.1560497283935547 L 6.751561164855957 10.81522941589355 C 6.751561164855957 11.28133010864258 6.373711109161377 11.6591796875 5.907621383666992 11.6591796875 L 0.8439412117004395 11.6591796875 C 0.3778514862060547 11.6591796875 1.430511474609375e-06 11.28133010864258 1.430511474609375e-06 10.81522941589355 L 1.430511474609375e-06 -0.1560497283935547 C 1.430511474609375e-06 -0.6221504211425781 0.3778514862060547 -1 0.8439412117004395 -1 Z"
                                stroke="none"
                                fill="red"
                            />
                        </g>
                        <g
                            id="Ellipse_1761"
                            data-name="Ellipse 1761"
                            transform="translate(-12286 8467.723)"
                            fill="none"
                            stroke="red"
                            stroke-width="0.7"
                        >
                            <ellipse
                                cx="5"
                                cy="2"
                                rx="5"
                                ry="2"
                                stroke="none"
                            />
                            <ellipse
                                cx="5"
                                cy="2"
                                rx="4.65"
                                ry="1.65"
                                fill="none"
                            />
                        </g>
                        <g
                            id="Path_7060"
                            data-name="Path 7060"
                            transform="matrix(0.985, -0.174, 0.174, 0.985, -12288.281, 8464.067)"
                            fill="none"
                        >
                            <path
                                d="M.289.334C.91.122,2.465-.364,6.03.472s3.347.59,3.347,1.013L8.955,3.663a.807.807,0,0,1-.844.765A10.322,10.322,0,0,1,6.33,4.114,14.505,14.505,0,0,0,3.538,3.7a8.2,8.2,0,0,0-2.577.263c-.021-.01-.42-1.2-.72-1.895C.241,1.649-.332.547.289.334Z"
                                stroke="none"
                            />
                            <path
                                d="M 2.488563537597656 0.7000033855438232 C 1.591588973999023 0.7000033855438232 1.036855697631836 0.8319008350372314 0.7091293334960938 0.9331130981445312 C 0.7308635711669922 1.074268341064453 0.7829875946044922 1.268774509429932 0.8153533935546875 1.389543294906616 C 0.8631381988525391 1.567825555801392 0.9089546203613281 1.738798379898071 0.9294300079345703 1.902814626693726 C 1.09056282043457 2.288315296173096 1.267749786376953 2.771849155426025 1.403729915618896 3.148141860961914 C 1.854195117950439 3.073963642120361 2.544107913970947 3.003313541412354 3.538093566894531 3.003313541412354 C 4.499293804168701 3.003313541412354 5.951053619384766 3.294643402099609 6.499393463134766 3.434683322906494 C 7.434735298156738 3.667490482330322 8.01649284362793 3.719292640686035 8.126338958740234 3.727488040924072 C 8.210105895996094 3.722321033477783 8.2518310546875 3.675616264343262 8.255013465881348 3.663293361663818 L 8.255013465881348 3.596153259277344 L 8.611480712890625 1.754865407943726 C 8.513428688049316 1.733961820602417 8.402975082397461 1.711000919342041 8.287103652954102 1.68691349029541 C 7.784923553466797 1.582513332366943 7.026023864746094 1.424753427505493 5.870304107666016 1.153683423995972 C 4.586803913116455 0.8526434898376465 3.449023723602295 0.7000033855438232 2.488563537597656 0.7000033855438232 M 2.488564014434814 -9.5367431640625e-07 C 3.360522747039795 -9.5367431640625e-07 4.513334274291992 0.1164157390594482 6.030143737792969 0.4721734523773193 C 9.595104217529297 1.308323383331299 9.376743316650391 1.062583446502686 9.376743316650391 1.484893321990967 L 8.955014228820801 3.663293361663818 C 8.955014228820801 4.0856032371521 8.577163696289062 4.427953243255615 8.11107349395752 4.427953243255615 C 8.11107349395752 4.427953243255615 7.464703559875488 4.396303176879883 6.330323696136475 4.113963603973389 C 5.826863765716553 3.985393285751343 4.417273998260498 3.70331335067749 3.538093566894531 3.70331335067749 C 1.639223575592041 3.70331335067749 0.961033821105957 3.966113328933716 0.961033821105957 3.966113328933716 C 0.9399042129516602 3.956263303756714 0.5407238006591797 2.766403436660767 0.2406139373779297 2.071593284606934 C 0.2406139373779297 1.649283409118652 -0.3318166732788086 0.5469233989715576 0.2891635894775391 0.334423303604126 C 0.6459369659423828 0.2123427391052246 1.311150550842285 -9.5367431640625e-07 2.488564014434814 -9.5367431640625e-07 Z"
                                stroke="none"
                                fill="red"
                            />
                        </g>
                        <g
                            id="Path_7061"
                            data-name="Path 7061"
                            transform="matrix(0.985, -0.174, 0.174, 0.985, -12289.624, 8461.073)"
                            fill="none"
                        >
                            <path
                                d="M.289.334C.91.122,2.465-.364,6.03.472s3.347.59,3.347,1.013L8.955,3.663a.807.807,0,0,1-.844.765A10.322,10.322,0,0,1,6.33,4.114,14.505,14.505,0,0,0,3.538,3.7a8.2,8.2,0,0,0-2.577.263c-.021-.01-.42-1.2-.72-1.895C.241,1.649-.332.547.289.334Z"
                                stroke="none"
                            />
                            <path
                                d="M 2.488563537597656 0.7000033855438232 C 1.591588973999023 0.7000033855438232 1.036855697631836 0.8319008350372314 0.7091293334960938 0.9331130981445312 C 0.7308635711669922 1.074268341064453 0.7829875946044922 1.268774509429932 0.8153533935546875 1.389543294906616 C 0.8631381988525391 1.567825555801392 0.9089546203613281 1.738798379898071 0.9294300079345703 1.902814626693726 C 1.09056282043457 2.288315296173096 1.267749786376953 2.771849155426025 1.403729915618896 3.148141860961914 C 1.854195117950439 3.073963642120361 2.544107913970947 3.003313541412354 3.538093566894531 3.003313541412354 C 4.499293804168701 3.003313541412354 5.951053619384766 3.294643402099609 6.499393463134766 3.434683322906494 C 7.434735298156738 3.667490482330322 8.01649284362793 3.719292640686035 8.126338958740234 3.727488040924072 C 8.210105895996094 3.722321033477783 8.2518310546875 3.675616264343262 8.255013465881348 3.663293361663818 L 8.255013465881348 3.596153259277344 L 8.611480712890625 1.754865407943726 C 8.513428688049316 1.733961820602417 8.402975082397461 1.711000919342041 8.287103652954102 1.68691349029541 C 7.784923553466797 1.582513332366943 7.026023864746094 1.424753427505493 5.870304107666016 1.153683423995972 C 4.586803913116455 0.8526434898376465 3.449023723602295 0.7000033855438232 2.488563537597656 0.7000033855438232 M 2.488564014434814 -9.5367431640625e-07 C 3.360522747039795 -9.5367431640625e-07 4.513334274291992 0.1164157390594482 6.030143737792969 0.4721734523773193 C 9.595104217529297 1.308323383331299 9.376743316650391 1.062583446502686 9.376743316650391 1.484893321990967 L 8.955014228820801 3.663293361663818 C 8.955014228820801 4.0856032371521 8.577163696289062 4.427953243255615 8.11107349395752 4.427953243255615 C 8.11107349395752 4.427953243255615 7.464703559875488 4.396303176879883 6.330323696136475 4.113963603973389 C 5.826863765716553 3.985393285751343 4.417273998260498 3.70331335067749 3.538093566894531 3.70331335067749 C 1.639223575592041 3.70331335067749 0.961033821105957 3.966113328933716 0.961033821105957 3.966113328933716 C 0.9399042129516602 3.956263303756714 0.5407238006591797 2.766403436660767 0.2406139373779297 2.071593284606934 C 0.2406139373779297 1.649283409118652 -0.3318166732788086 0.5469233989715576 0.2891635894775391 0.334423303604126 C 0.6459369659423828 0.2123427391052246 1.311150550842285 -9.5367431640625e-07 2.488564014434814 -9.5367431640625e-07 Z"
                                stroke="none"
                                fill="red"
                            />
                        </g>
                        <g
                            id="Path_7062"
                            data-name="Path 7062"
                            transform="matrix(0.985, -0.174, 0.174, 0.985, -12291.27, 8458.153)"
                            fill="none"
                        >
                            <path
                                d="M.245.334c.621-.212,2.176-.7,5.741.138s3.347.59,3.347,1.013L8.911,3.663a.807.807,0,0,1-.844.765,10.322,10.322,0,0,1-1.781-.314A14.505,14.505,0,0,0,3.494,3.7a8.2,8.2,0,0,0-2.577.263,15.077,15.077,0,0,0-.54-1.832C.378,1.712-.376.547.245.334Z"
                                stroke="none"
                            />
                            <path
                                d="M 2.444878101348877 0.7000033855438232 C 1.609920024871826 0.7000033855438232 1.071453094482422 0.8143110275268555 0.7366504669189453 0.911752462387085 C 0.7750225067138672 1.046494245529175 0.8349370956420898 1.210765838623047 0.8738584518432617 1.317463397979736 C 0.9591922760009766 1.551426649093628 1.035435676574707 1.760449171066284 1.06474494934082 1.963981866836548 C 1.214789867401123 2.337043762207031 1.338732719421387 2.775201320648193 1.431166172027588 3.13677978515625 C 1.881997585296631 3.066911697387695 2.551355838775635 3.003313541412354 3.494408130645752 3.003313541412354 C 4.455608367919922 3.003313541412354 5.907368659973145 3.294643402099609 6.455708503723145 3.434683322906494 C 7.391050338745117 3.667490482330322 7.97280740737915 3.719292879104614 8.082653999328613 3.727488040924072 C 8.166422843933105 3.7223219871521 8.208155632019043 3.675625562667847 8.211328506469727 3.663293361663818 L 8.211328506469727 3.596153259277344 L 8.567794799804688 1.754865407943726 C 8.469742774963379 1.733961820602417 8.35929012298584 1.711000919342041 8.24341869354248 1.68691349029541 C 7.741238594055176 1.582513332366943 6.982338428497314 1.424753427505493 5.826618194580078 1.153683423995972 C 4.543118476867676 0.8526434898376465 3.405338287353516 0.7000033855438232 2.444878101348877 0.7000033855438232 M 2.444882869720459 -9.5367431640625e-07 C 3.316842079162598 -9.5367431640625e-07 4.469653129577637 0.1164157390594482 5.986458301544189 0.4721734523773193 C 9.551418304443359 1.308323383331299 9.33305835723877 1.062583446502686 9.33305835723877 1.484893321990967 L 8.911328315734863 3.663293361663818 C 8.911328315734863 4.0856032371521 8.533488273620605 4.427953243255615 8.067388534545898 4.427953243255615 C 8.067388534545898 4.427953243255615 7.421018600463867 4.396303176879883 6.286638259887695 4.113963603973389 C 5.783178329467773 3.985393285751343 4.373588562011719 3.70331335067749 3.494408130645752 3.70331335067749 C 1.595538139343262 3.70331335067749 0.9173479080200195 3.966113328933716 0.9173479080200195 3.966113328933716 C 0.8962182998657227 3.956263303756714 0.6776180267333984 2.829203367233276 0.3774986267089844 2.134403228759766 C 0.3774986267089844 1.712093353271484 -0.3755016326904297 0.5469233989715576 0.245478630065918 0.334423303604126 C 0.6022520065307617 0.2123427391052246 1.267468452453613 -9.5367431640625e-07 2.444882869720459 -9.5367431640625e-07 Z"
                                stroke="none"
                                fill="red"
                            />
                        </g>
                        <g
                            id="Path_7063"
                            data-name="Path 7063"
                            transform="matrix(0.985, -0.174, 0.174, 0.985, -12292.156, 8455.629)"
                            fill="none"
                        >
                            <path
                                d="M.289.334C.91.122,2.465-.364,6.03.472s3.347.59,3.347,1.013L8.955,3.663a.807.807,0,0,1-.844.765A10.322,10.322,0,0,1,6.33,4.114,14.505,14.505,0,0,0,3.538,3.7a8.2,8.2,0,0,0-2.577.263c-.021-.01-.42-1.2-.72-1.895C.241,1.649-.332.547.289.334Z"
                                stroke="none"
                            />
                            <path
                                d="M 2.488563537597656 0.7000033855438232 C 1.591588973999023 0.7000033855438232 1.036855697631836 0.8319008350372314 0.7091293334960938 0.9331130981445312 C 0.7308635711669922 1.074268341064453 0.7829875946044922 1.268774509429932 0.8153533935546875 1.389543294906616 C 0.8631381988525391 1.567825555801392 0.9089546203613281 1.738798379898071 0.9294300079345703 1.902814626693726 C 1.09056282043457 2.288315296173096 1.267749786376953 2.771849155426025 1.403729915618896 3.148141860961914 C 1.854195117950439 3.073963642120361 2.544107913970947 3.003313541412354 3.538093566894531 3.003313541412354 C 4.499293804168701 3.003313541412354 5.951053619384766 3.294643402099609 6.499393463134766 3.434683322906494 C 7.434735298156738 3.667490482330322 8.01649284362793 3.719292640686035 8.126338958740234 3.727488040924072 C 8.210105895996094 3.722321033477783 8.2518310546875 3.675616264343262 8.255013465881348 3.663293361663818 L 8.255013465881348 3.596153259277344 L 8.611480712890625 1.754865407943726 C 8.513428688049316 1.733961820602417 8.402975082397461 1.711000919342041 8.287103652954102 1.68691349029541 C 7.784923553466797 1.582513332366943 7.026023864746094 1.424753427505493 5.870304107666016 1.153683423995972 C 4.586803913116455 0.8526434898376465 3.449023723602295 0.7000033855438232 2.488563537597656 0.7000033855438232 M 2.488564014434814 -9.5367431640625e-07 C 3.360522747039795 -9.5367431640625e-07 4.513334274291992 0.1164157390594482 6.030143737792969 0.4721734523773193 C 9.595104217529297 1.308323383331299 9.376743316650391 1.062583446502686 9.376743316650391 1.484893321990967 L 8.955014228820801 3.663293361663818 C 8.955014228820801 4.0856032371521 8.577163696289062 4.427953243255615 8.11107349395752 4.427953243255615 C 8.11107349395752 4.427953243255615 7.464703559875488 4.396303176879883 6.330323696136475 4.113963603973389 C 5.826863765716553 3.985393285751343 4.417273998260498 3.70331335067749 3.538093566894531 3.70331335067749 C 1.639223575592041 3.70331335067749 0.961033821105957 3.966113328933716 0.961033821105957 3.966113328933716 C 0.9399042129516602 3.956263303756714 0.5407238006591797 2.766403436660767 0.2406139373779297 2.071593284606934 C 0.2406139373779297 1.649283409118652 -0.3318166732788086 0.5469233989715576 0.2891635894775391 0.334423303604126 C 0.6459369659423828 0.2123427391052246 1.311150550842285 -9.5367431640625e-07 2.488564014434814 -9.5367431640625e-07 Z"
                                stroke="none"
                                fill="red"
                            />
                        </g>
                        <line
                            id="Line_1316"
                            data-name="Line 1316"
                            y1="2.532"
                            transform="translate(-12289.202 8465.394)"
                            fill="none"
                            stroke="red"
                            stroke-linecap="round"
                            stroke-width="0.7"
                        />
                        <line
                            id="Line_1317"
                            data-name="Line 1317"
                            y1="2.532"
                            transform="translate(-12289.202 8465.394)"
                            fill="none"
                            stroke="red"
                            stroke-linecap="round"
                            stroke-width="0.7"
                        />
                        <line
                            id="Line_1318"
                            data-name="Line 1318"
                            y1="5.064"
                            transform="translate(-12290.891 8462.861)"
                            fill="none"
                            stroke="red"
                            stroke-linecap="round"
                            stroke-width="0.7"
                        />
                    </g>
                </svg>
            );
        case MiniatureGolfCourseTitles.some(
            (t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle
        ):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_11108"
                        data-name="Group 11108"
                        transform="translate(-25 -484)"
                    >
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 484)"
                            fill="#e2a500"
                            opacity="0.1"
                        />
                    </g>
                    <g id="golf-club-1" transform="translate(-147 -201.855)">
                        <path
                            id="Path_7064"
                            data-name="Path 7064"
                            d="M166.214,487.966h-8.34A1.9,1.9,0,0,1,156,486.045v-5.051a1.93,1.93,0,0,1,.672-1.471,1.85,1.85,0,0,1,1.481-.427l10.141,1.559a1.862,1.862,0,0,1,1.147.652,1.944,1.944,0,0,1,.447,1.246v.14l-1.991,4.194A1.88,1.88,0,0,1,166.214,487.966Zm-8.343-7.643a.586.586,0,0,0-.387.147.685.685,0,0,0-.235.525v5.053a.65.65,0,0,0,.624.672h8.34a.619.619,0,0,0,.557-.367l1.858-3.917a.647.647,0,0,0-.527-.545l-10.141-1.559A.369.369,0,0,0,157.871,480.322Z"
                            transform="translate(0 -260.545)"
                            fill="#e2a500"
                        />
                        <path
                            id="Path_7065"
                            data-name="Path 7065"
                            d="M188.548,222.525H186v-1.249h2.548a.374.374,0,0,1,.375.375v.5A.374.374,0,0,1,188.548,222.525Zm0,2.545H186v-1.249h2.548a.374.374,0,0,1,.375.375v.5A.374.374,0,0,1,188.548,225.07Zm9.035.357-1.124-.547,6.232-12.814a.373.373,0,0,1,.5-.172l.45.217a.371.371,0,0,1,.172.5Z"
                            transform="translate(-29.251)"
                            fill="#e2a500"
                        />
                    </g>
                </svg>
            );

        case EquestrianTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_11109"
                        data-name="Group 11109"
                        transform="translate(-25 -484)"
                    >
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 484)"
                            fill="#009545"
                            opacity="0.1"
                        />
                    </g>
                    <g
                        id="_9025649_horse_icon"
                        data-name="9025649_horse_icon"
                        transform="translate(7 8.274)"
                    >
                        <rect
                            id="Rectangle_17148"
                            data-name="Rectangle 17148"
                            width="22"
                            height="22"
                            transform="translate(0 -0.274)"
                            fill="none"
                        />
                        <path
                            id="Path_7100"
                            data-name="Path 7100"
                            d="M132.091,120A4.091,4.091,0,0,1,128,124.091"
                            transform="translate(-117.09 -109.866)"
                            fill="none"
                            stroke="#009545"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                        />
                        <path
                            id="Path_7101"
                            data-name="Path 7101"
                            d="M20.091,46.285A8.184,8.184,0,1,0,25.546,32h-.682v2.728L16,40.183l1.176,1.628a2.037,2.037,0,0,0,2,.818,9.515,9.515,0,0,1,6.367.963h0l-3,4.2"
                            transform="translate(-14.636 -29.366)"
                            fill="none"
                            stroke="#009545"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1"
                        />
                        <circle
                            id="Ellipse_1771"
                            data-name="Ellipse 1771"
                            cx="1"
                            cy="1"
                            r="1"
                            transform="translate(10 7.726)"
                            fill="#009545"
                        />
                    </g>
                </svg>
            );

        case ObservatoryDeckTitles.some(
            (t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle
        ):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <circle
                        id="Ellipse_1762"
                        data-name="Ellipse 1762"
                        cx="18"
                        cy="18"
                        r="18"
                        fill="#1cb0bd"
                        opacity="0.1"
                    />
                    <path
                        id="_5310241_astronomy_observation_science_telescope_icon"
                        data-name="5310241_astronomy_observation_science_telescope_icon"
                        d="M39.116,64.843l-2.082.47a1.065,1.065,0,0,1-1.276-.806l-1.1-4.858a1.068,1.068,0,0,1,.806-1.276l2.082-.47h0a1.068,1.068,0,0,1,1.276.806l1.1,4.858A1.068,1.068,0,0,1,39.116,64.843Zm-14.9-1.375a.356.356,0,0,0-.425-.269l-1.448.327a1.069,1.069,0,0,0-1.138-.472h0l-.694.157a1.068,1.068,0,0,0-.806,1.276l.47,2.082a1.067,1.067,0,0,0,1.276.806l.694-.157a1.069,1.069,0,0,0,.825-.916l1.448-.327a.356.356,0,0,0,.269-.425Zm11.964,9.773a.356.356,0,1,1-.6.382l-4.241-6.665c-.041.013-.083.026-.126.035a1.426,1.426,0,0,1-.315.035,1.41,1.41,0,0,1-.481-.085l-4.56,6.689a.356.356,0,0,1-.588-.4l4.56-6.689a1.422,1.422,0,0,1-.2-.287l-2.82.637a1.065,1.065,0,0,1-1.276-.806l-.784-3.47a1.067,1.067,0,0,1,.806-1.276l7.981-1.8a.356.356,0,0,1,.425.269l1.1,4.858a.356.356,0,0,1-.269.425l-2.472.559a1.414,1.414,0,0,1-.384.927ZM31.057,66.3a.712.712,0,1,0-.418-.033.712.712,0,0,0,.418.033Zm-6.56-8.52h.711v.711a.356.356,0,0,0,.711,0v-.711h.711a.356.356,0,1,0,0-.711H25.92v-.711a.356.356,0,0,0-.711,0v.711H24.5a.356.356,0,1,0,0,.711ZM37.659,67.74a1.067,1.067,0,1,0,1.067,1.067,1.067,1.067,0,0,0-1.067-1.067Z"
                        transform="translate(-12.68 -46.894)"
                        fill="#1cb0bd"
                    />
                </svg>
            );
        case ZenGardenTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <circle
                        id="Ellipse_1763"
                        data-name="Ellipse 1763"
                        cx="18"
                        cy="18"
                        r="18"
                        fill="#16519e"
                        opacity="0.1"
                    />
                    <g
                        id="_7099598_garden_sprout_ecology_plant_botany_icon"
                        data-name="7099598_garden_sprout_ecology_plant_botany_icon"
                        transform="translate(-21.053 -25.508)"
                    >
                        <path
                            id="Path_7066"
                            data-name="Path 7066"
                            d="M104.718,37.813a2.2,2.2,0,0,0-2.5-.943,5.946,5.946,0,0,0-4.432,4.2,5.951,5.951,0,0,0-4.432-4.2,2.2,2.2,0,0,0-2.5.943,2.146,2.146,0,0,0,.212,2.6c1.237,1.427,3.428,2.162,6.5,2.195V52.878a.214.214,0,0,0,.428,0V42.6c3.075-.033,5.266-.768,6.5-2.195A2.142,2.142,0,0,0,104.718,37.813Zm-13.495.229a1.755,1.755,0,0,1,1.5-.831,1.943,1.943,0,0,1,.521.072,5.456,5.456,0,0,1,4.3,4.672L94.2,39.522a.214.214,0,0,0-.251.346L97.1,42.162c-2.693-.1-4.618-.777-5.707-2.035A1.706,1.706,0,0,1,91.223,38.042Zm7.254,4.12,3.157-2.293a.214.214,0,0,0-.251-.346l-3.348,2.433a5.455,5.455,0,0,1,4.3-4.672,1.941,1.941,0,0,1,.519-.072,1.755,1.755,0,0,1,1.5.831,1.7,1.7,0,0,1-.173,2.086c-1.091,1.257-3.016,1.936-5.709,2.035Z"
                            transform="translate(-57.624)"
                            fill="#16519e"
                            stroke="#16519e"
                            stroke-width="0.5"
                        />
                        <path
                            id="Path_7067"
                            data-name="Path 7067"
                            d="M37.085,239.374a3.34,3.34,0,0,0-2.376,2.058,3.34,3.34,0,0,0-2.376-2.058,1.29,1.29,0,0,0-1.463.553,1.261,1.261,0,0,0,.124,1.525,4.59,4.59,0,0,0,3.5,1.221v5.211a.214.214,0,0,0,.428,0v-5.213a4.6,4.6,0,0,0,3.5-1.221,1.261,1.261,0,0,0,.123-1.525A1.289,1.289,0,0,0,37.085,239.374Zm-5.852.781a.869.869,0,0,1,.729-.406.95.95,0,0,1,.257.037,2.881,2.881,0,0,1,2.223,2.219l-1.623-1.179a.214.214,0,1,0-.251.346l1.446,1.051a3.818,3.818,0,0,1-2.7-1.054.829.829,0,0,1-.085-1.014Zm6.868,1.015a3.817,3.817,0,0,1-2.7,1.054l1.446-1.051a.214.214,0,1,0-.252-.346l-1.623,1.179a2.88,2.88,0,0,1,2.223-2.219.948.948,0,0,1,.257-.037.869.869,0,0,1,.729.406A.832.832,0,0,1,38.1,241.171Z"
                            transform="translate(0 -195.006)"
                            fill="#16519e"
                            stroke="#16519e"
                            stroke-width="0.5"
                        />
                    </g>
                </svg>
            );

        case joggingTrackTitles.some(
            (t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle
        ):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_11110"
                        data-name="Group 11110"
                        transform="translate(-25 -484)"
                    >
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 484)"
                            fill="red"
                            opacity="0.1"
                        />
                    </g>
                    <g
                        id="_x30_1_x2C__running_x2C__walking_x2C__jogging_x2C__run_x2C__exercise_x2C__shoes"
                        transform="translate(9 9)"
                    >
                        <g
                            id="Group_11113"
                            data-name="Group 11113"
                            transform="translate(0)"
                        >
                            <g id="Group_11112" data-name="Group 11112">
                                <g id="XMLID_1_">
                                    <g
                                        id="XMLID_15_"
                                        transform="translate(0.987 7.586)"
                                    >
                                        <path
                                            id="XMLID_16_"
                                            d="M44.9,228.074H39.216a.39.39,0,0,1-.182-.045l-.557-.3,2.917-2.915a.344.344,0,1,0-.486-.486L37.841,227.4l-1.421-.755,3.639-3.634a.344.344,0,0,0-.486-.487L35.785,226.3l-1.421-.755,4.314-4.309a.344.344,0,0,0-.486-.487l-4.464,4.458L29.2,222.806a.344.344,0,0,0-.323.607l9.834,5.223a1.08,1.08,0,0,0,.5.126H44.9a.344.344,0,1,0,0-.688Z"
                                            transform="translate(-28.695 -220.652)"
                                            fill="red"
                                        />
                                    </g>
                                    <g id="XMLID_2_">
                                        <path
                                            id="XMLID_5_"
                                            d="M15.522,12.588c-1.8-.585-2.183-2.06-4.361-4.676L16.4.543A.344.344,0,0,0,16.12,0H9.9a.344.344,0,0,0-.266.127L4.923,5.9l-.31-.31a.344.344,0,0,0-.522.042C-.149,11.507.1,11.154.075,11.2a.709.709,0,0,0,.33.958l5.014,2.482H2.174a.344.344,0,1,0,0,.688H6.808l1.569.777H5.1a.344.344,0,1,0,0,.688H9.766l1.253.62a1.082,1.082,0,0,0,.477.112H15.36a2.177,2.177,0,0,0,2.174-2.175A2.909,2.909,0,0,0,15.522,12.588ZM10.061.688h5.393L12.244,5.2,8.006,3.208Zm-2.5,3.07,4.282,2.014L10.547,7.59l-3.841.093L5.412,6.39Zm7.8,13.08H11.5a.39.39,0,0,1-.172-.04L.7,11.539a.022.022,0,0,1-.013-.019L4.413,6.363,6.323,8.274a.345.345,0,0,0,.251.1l4-.1c2.243,2.672,2.653,4.285,4.739,4.964a2.223,2.223,0,0,1,1.537,2.11A1.488,1.488,0,0,1,15.36,16.838Z"
                                            transform="translate(0)"
                                            fill="red"
                                        />
                                        <path
                                            id="XMLID_4_"
                                            d="M.717,425.869H.351a.344.344,0,0,0,0,.688H.717a.344.344,0,0,0,0-.688Z"
                                            transform="translate(-0.007 -411.227)"
                                            fill="red"
                                        />
                                        <path
                                            id="XMLID_3_"
                                            d="M85.891,468.456h-.366a.344.344,0,1,0,0,.688h.366a.344.344,0,1,0,0-.688Z"
                                            transform="translate(-82.252 -452.35)"
                                            fill="red"
                                        />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            );

        case MeditationRoomTitles.some(
            (t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle
        ):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_11114"
                        data-name="Group 11114"
                        transform="translate(-25 -484)"
                    >
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 484)"
                            fill="#e2a500"
                            opacity="0.1"
                        />
                    </g>
                    <g id="Layer_x0020_1" transform="translate(6 6)">
                        <path
                            id="Path_7068"
                            data-name="Path 7068"
                            d="M8.423,3.6A2.936,2.936,0,1,1,5.487.661h0A2.936,2.936,0,0,1,8.422,3.6h0ZM7.044,5.154A2.2,2.2,0,0,0,7.689,3.6h0a2.2,2.2,0,0,0-2.2-2.2h0A2.2,2.2,0,1,0,7.044,5.154Z"
                            transform="translate(6.227 1.612)"
                            fill="#e2a500"
                        />
                        <path
                            id="Path_7069"
                            data-name="Path 7069"
                            d="M4.909,4.206V6.775a.367.367,0,0,1-.357.367c-.263.02-.545.034-.813.047a7.651,7.651,0,0,0-1.383.143.367.367,0,0,1-.272-.674A5.34,5.34,0,0,0,3.259,5.5a13.1,13.1,0,0,0,.965-1.479.365.365,0,0,1,.682.182h0ZM4.175,6.433V5.488c-.108.157-.22.312-.336.462-.14.181-.288.357-.442.524L3.7,6.458c.149-.007.3-.015.47-.025Z"
                            transform="translate(4.634 9.374)"
                            fill="#e2a500"
                        />
                        <path
                            id="Path_7070"
                            data-name="Path 7070"
                            d="M4.77,5.488v.945c.166.01.321.018.47.025l.309.016c-.155-.167-.3-.343-.442-.524-.116-.151-.228-.305-.336-.462ZM4.035,6.775V4.206h0a.365.365,0,0,1,.682-.182A13.1,13.1,0,0,0,5.685,5.5,5.34,5.34,0,0,0,6.861,6.658a.367.367,0,0,1-.272.674A7.651,7.651,0,0,0,5.2,7.189c-.267-.013-.55-.027-.813-.047a.367.367,0,0,1-.357-.367Z"
                            transform="translate(9.85 9.374)"
                            fill="#e2a500"
                        />
                        <path
                            id="Path_7071"
                            data-name="Path 7071"
                            d="M7.323,3.446A7.039,7.039,0,0,0,5.19,6.2l0,0A15.273,15.273,0,0,1,4.01,8.11,3.278,3.278,0,0,1,2.377,9.358a.654.654,0,0,0-.337.224.622.622,0,0,0-.134.363h0v.037q0,.009,0,.019,0,.029.006.059a.645.645,0,0,0,.253.409.676.676,0,0,0,.4.129l.037,0a1.674,1.674,0,0,0,.209-.008.589.589,0,0,0,.119-.026,1.55,1.55,0,0,0,.323-.173l.007,0a4.84,4.84,0,0,1,.5-.286l.119-.059A.366.366,0,0,1,4.2,10.7a5.429,5.429,0,0,0-.555.312l-.022.014a1.747,1.747,0,0,0-.282.238.547.547,0,0,0-.164.3,1.232,1.232,0,0,0,.05.536,1.341,1.341,0,0,0,.283.483h0a.426.426,0,0,0,.031.031c.613.553,2.951.83,5.312.83s4.7-.277,5.312-.83a.426.426,0,0,0,.031-.031l.018-.018a1.337,1.337,0,0,0,.267-.465,1.232,1.232,0,0,0,.05-.536.547.547,0,0,0-.164-.3,1.747,1.747,0,0,0-.282-.238l-.022-.014A5.429,5.429,0,0,0,13.5,10.7h0a.366.366,0,0,1,.317-.659h0l.119.059a4.84,4.84,0,0,1,.5.286l.007,0a1.55,1.55,0,0,0,.323.173.589.589,0,0,0,.119.026,1.825,1.825,0,0,0,.24.008h.006a.676.676,0,0,0,.4-.129.645.645,0,0,0,.253-.409.612.612,0,0,0,.007-.078h0V9.945c0-.006,0-.012,0-.018a.623.623,0,0,0-.133-.345.654.654,0,0,0-.337-.224A3.278,3.278,0,0,1,13.69,8.11,15.273,15.273,0,0,1,12.511,6.2l0,0a7.039,7.039,0,0,0-2.133-2.755A3.472,3.472,0,0,0,8.85,3.185a3.472,3.472,0,0,0-1.527.261Zm-2.772,2.4a7.522,7.522,0,0,1,2.4-3.027,4.133,4.133,0,0,1,1.9-.367,4.133,4.133,0,0,1,1.9.367,7.522,7.522,0,0,1,2.4,3.027l0,0a14.752,14.752,0,0,0,1.118,1.814,2.6,2.6,0,0,0,1.255.991,1.389,1.389,0,0,1,.713.479,1.352,1.352,0,0,1,.287.768.369.369,0,0,1,0,.045v.037h0v.006a1.4,1.4,0,0,1-.056.363,1.359,1.359,0,0,1-.5.709,1.414,1.414,0,0,1-.74.269,1.142,1.142,0,0,1,.03.153,1.958,1.958,0,0,1-.082.851,2.068,2.068,0,0,1-.417.724l-.019.023a1.173,1.173,0,0,1-.086.085c-.753.68-3.29,1.019-5.8,1.019s-5.049-.34-5.8-1.019a1.174,1.174,0,0,1-.086-.085h0a2.074,2.074,0,0,1-.437-.746,1.958,1.958,0,0,1-.082-.851,1.142,1.142,0,0,1,.03-.153,1.414,1.414,0,0,1-.74-.269,1.341,1.341,0,0,1-.543-.888,1.338,1.338,0,0,1-.015-.145.371.371,0,0,1,0-.045V9.945h0V9.938a1.351,1.351,0,0,1,.289-.806,1.389,1.389,0,0,1,.713-.479,2.6,2.6,0,0,0,1.255-.99A14.752,14.752,0,0,0,4.549,5.848l0,0Z"
                            transform="translate(2.864 5.982)"
                            fill="#e2a500"
                        />
                        <rect
                            id="Rectangle_17144"
                            data-name="Rectangle 17144"
                            width="23.489"
                            height="23.489"
                            fill="none"
                        />
                    </g>
                </svg>
            );

        case OutdoorTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_9463"
                        data-name="Group 9463"
                        transform="translate(-25 -873)"
                    >
                        <g id="Group_946" data-name="Group 946">
                            <circle
                                id="Ellipse_160"
                                data-name="Ellipse 160"
                                cx="18"
                                cy="18"
                                r="18"
                                transform="translate(25 873)"
                                fill="#1cb0bd"
                                opacity="0.1"
                            />
                        </g>
                        <g
                            id="_172468_ball_soccer_football_icon"
                            data-name="172468_ball_soccer_football_icon"
                            transform="translate(34 882)"
                        >
                            <rect
                                id="Rectangle_1060"
                                data-name="Rectangle 1060"
                                width="18"
                                height="18"
                                fill="none"
                            />
                            <g
                                id="Group_956"
                                data-name="Group 956"
                                transform="translate(0.737 0.737)"
                            >
                                <path
                                    id="Path_2303"
                                    data-name="Path 2303"
                                    d="M10.479,2a8.479,8.479,0,1,0,8.479,8.479A8.479,8.479,0,0,0,10.479,2Z"
                                    transform="translate(-2 -2)"
                                    fill="none"
                                    stroke="#1cb0bd"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeMiterlimit="10"
                                    strokeWidth="1"
                                />
                            </g>
                            <path
                                id="Path_2304"
                                data-name="Path 2304"
                                d="M16.242,22.4,14.8,17.951,18.57,15.2l3.77,2.748L20.9,22.4Z"
                                transform="translate(-9.345 -9.599)"
                                fill="none"
                                stroke="#1cb0bd"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit="10"
                                strokeWidth="1"
                            />
                            <path
                                id="Path_2305"
                                data-name="Path 2305"
                                d="M22.738,3.788l-3.212,1.37-3.211-1.37"
                                transform="translate(-10.301 -2.392)"
                                fill="none"
                                stroke="#1cb0bd"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit="10"
                                strokeWidth="1"
                            />
                            <path
                                id="Path_2306"
                                data-name="Path 2306"
                                d="M4.247,10.106l.309,3.488L2.263,16.234"
                                transform="translate(-1.429 -6.381)"
                                fill="none"
                                stroke="#1cb0bd"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit="10"
                                strokeWidth="1"
                            />
                            <path
                                id="Path_2307"
                                data-name="Path 2307"
                                d="M5.576,36.957l3.4.783,1.795,3"
                                transform="translate(-3.521 -23.333)"
                                fill="none"
                                stroke="#1cb0bd"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit="10"
                                strokeWidth="1"
                            />
                            <path
                                id="Path_2308"
                                data-name="Path 2308"
                                d="M30.388,40.741l1.793-3,3.4-.783"
                                transform="translate(-19.186 -23.331)"
                                fill="none"
                                stroke="#1cb0bd"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit="10"
                                strokeWidth="1"
                            />
                            <path
                                id="Path_2309"
                                data-name="Path 2309"
                                d="M43.863,16.233l-2.295-2.641.308-3.486"
                                transform="translate(-26.245 -6.381)"
                                fill="none"
                                stroke="#1cb0bd"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit="10"
                                strokeWidth="1"
                            />
                            <line
                                id="Line_205"
                                data-name="Line 205"
                                y2="2.838"
                                transform="translate(9.225 2.767)"
                                fill="none"
                                stroke="#1cb0bd"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit="10"
                                strokeWidth="1"
                            />
                            <line
                                id="Line_206"
                                data-name="Line 206"
                                y1="1.251"
                                x2="2.328"
                                transform="translate(12.995 7.212)"
                                fill="none"
                                stroke="#1cb0bd"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit="10"
                                strokeWidth="1"
                            />
                            <line
                                id="Line_207"
                                data-name="Line 207"
                                x2="1.44"
                                y2="1.607"
                                transform="translate(11.556 12.799)"
                                fill="none"
                                stroke="#1cb0bd"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit="10"
                                strokeWidth="1"
                            />
                            <line
                                id="Line_208"
                                data-name="Line 208"
                                x1="1.44"
                                y2="1.608"
                                transform="translate(5.457 12.799)"
                                fill="none"
                                stroke="#1cb0bd"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit="10"
                                strokeWidth="1"
                            />
                            <line
                                id="Line_209"
                                data-name="Line 209"
                                x2="2.329"
                                y2="1.138"
                                transform="translate(3.127 7.214)"
                                fill="none"
                                stroke="#1cb0bd"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeMiterlimit="10"
                                strokeWidth="1"
                            />
                        </g>
                    </g>
                </svg>
            );

        case IndoorGamesTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_9462"
                        data-name="Group 9462"
                        transform="translate(-25 -807)"
                    >
                        <g id="Group_892" data-name="Group 892">
                            <g id="Group_947" data-name="Group 947">
                                <circle
                                    id="Ellipse_159"
                                    data-name="Ellipse 159"
                                    cx="18"
                                    cy="18"
                                    r="18"
                                    transform="translate(25 807)"
                                    fill="red"
                                    opacity="0.1"
                                />
                            </g>
                        </g>
                        <g
                            id="Layer_2"
                            data-name="Layer 2"
                            transform="translate(32.696 813.86)"
                        >
                            <path
                                id="Path_2302"
                                data-name="Path 2302"
                                d="M18.58,12.547a7.192,7.192,0,0,0-1.019-8.458A6.749,6.749,0,0,0,12.744,2.14h0a8.255,8.255,0,0,0-8.078,8.078,6.979,6.979,0,0,0,.567,2.772l-2.657,1.9A3,3,0,0,0,4.347,20.35h.23a3,3,0,0,0,2.2-1.249l1.913-2.657a7.086,7.086,0,0,0,2.772.567,7.617,7.617,0,0,0,2.507-.434,3.091,3.091,0,1,0,4.641-4ZM8.333,5.816a6.315,6.315,0,0,1,4.429-1.9h0A4.986,4.986,0,0,1,16.3,5.346a5.42,5.42,0,0,1,.673,6.412,3.056,3.056,0,0,0-.425,0,3.1,3.1,0,0,0-3.011,2.383L7.04,7.649A6.59,6.59,0,0,1,8.333,5.816ZM5.313,18.065a1.231,1.231,0,0,1-.886.514,1.2,1.2,0,0,1-.974-.354A1.213,1.213,0,0,1,3.1,17.25a1.231,1.231,0,0,1,.514-.886L6.163,14.54a6.537,6.537,0,0,0,.469.523,6.4,6.4,0,0,0,.523.469Zm2.551-4.278a4.978,4.978,0,0,1-1.426-3.543,5.687,5.687,0,0,1,0-.629l5.571,5.571A5.093,5.093,0,0,1,7.863,13.787Zm8.671,2.4a1.329,1.329,0,1,1,1.329-1.329A1.329,1.329,0,0,1,16.534,16.187Z"
                                transform="translate(0 0)"
                                fill="red"
                                stroke="#ffe5e5"
                                strokeWidth="0.8"
                            />
                        </g>
                    </g>
                </svg>
            );

        case tennisCourtTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_11124"
                        data-name="Group 11124"
                        transform="translate(-25 -484)"
                    >
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 484)"
                            fill="#009545"
                            opacity="0.1"
                        />
                    </g>
                    <g id="Layer_4" transform="translate(6.637 8.964)">
                        <g
                            id="Group_11125"
                            data-name="Group 11125"
                            transform="translate(4.363 -0.007)"
                        >
                            <path
                                id="Path_7082"
                                data-name="Path 7082"
                                d="M8.022,27.857a3.659,3.659,0,1,0,3.659,3.658A3.659,3.659,0,0,0,8.022,27.857Zm0,6.4a2.744,2.744,0,0,1-2.744-2.745c0-.05,0-.1.008-.147a8.249,8.249,0,0,1,2.952,2.881C8.167,34.255,8.1,34.26,8.022,34.26Zm1.131-.246A9.163,9.163,0,0,0,5.5,30.444,2.748,2.748,0,0,1,7.17,28.909,9.158,9.158,0,0,0,10.3,33.05,2.752,2.752,0,0,1,9.152,34.014ZM10.677,32.2A8.246,8.246,0,0,1,8.1,28.776,2.732,2.732,0,0,1,10.677,32.2Z"
                                transform="translate(-4.363 -17.739)"
                                fill="#009545"
                                stroke="#009545"
                                stroke-width="0.2"
                            />
                            <path
                                id="Path_7083"
                                data-name="Path 7083"
                                d="M22.181,9.683h0A4.422,4.422,0,0,0,23.268,4.7l.007,0-.922-1.978-.01,0c-.024-.06-.045-.121-.073-.18a4.421,4.421,0,1,0-8.013,3.737c.027.059.06.114.09.171l-.008,0,.922,1.978.008,0a4.422,4.422,0,0,0,4.556,2.361L21.253,11.8l.751-.35Zm-1.488-.059a3.535,3.535,0,0,1-4.7-1.7h0l-.938-2.012a3.535,3.535,0,0,1,6.375-3.057h0l.025.053.008.015a.036.036,0,0,1,0,.01L22.4,4.914l.005.009a.144.144,0,0,0,.006.016l.042.091,0,0A3.534,3.534,0,0,1,20.693,9.624Z"
                                transform="translate(-10.401 0.007)"
                                fill="#009545"
                                stroke="#009545"
                                stroke-width="0.2"
                            />
                            <path
                                id="Path_7084"
                                data-name="Path 7084"
                                d="M36.073,33.784l-.8.368,2.237,4.8.8-.373Z"
                                transform="translate(-24.046 -21.513)"
                                fill="#009545"
                                stroke="#009545"
                                stroke-width="0.2"
                            />
                        </g>
                    </g>
                </svg>
            );

        case basketballCourtTitles.some(
            (t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle
        ):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_11115"
                        data-name="Group 11115"
                        transform="translate(-25 -484)"
                    >
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 484)"
                            fill="#009545"
                            opacity="0.1"
                        />
                    </g>
                    <g id="Page-1" transform="translate(5 4.957)">
                        <g id="icon-1-basketball" transform="translate(4 4)">
                            <path
                                id="basketball"
                                d="M13.4,4.731a8.288,8.288,0,0,1,5.277,2.194h0A9.008,9.008,0,0,0,16.3,12.681H13.4V4.731Zm-.723,0A8.288,8.288,0,0,0,7.4,6.925h0A9.008,9.008,0,0,1,9.78,12.681h2.9V4.731ZM13.4,21.354a8.288,8.288,0,0,0,5.277-2.194h0A9.008,9.008,0,0,1,16.3,13.4H13.4v7.95Zm-.723,0A8.288,8.288,0,0,1,7.4,19.16,9.008,9.008,0,0,0,9.78,13.4h2.9v7.95ZM19.191,7.439a8.287,8.287,0,0,1,2.162,5.242H17.029a8.287,8.287,0,0,1,2.162-5.242Zm0,11.207A8.287,8.287,0,0,0,21.354,13.4H17.029a8.287,8.287,0,0,0,2.162,5.242ZM4.731,12.681A8.287,8.287,0,0,1,6.894,7.439h0a8.287,8.287,0,0,1,2.162,5.242Zm0,.723a8.287,8.287,0,0,0,2.162,5.242A8.287,8.287,0,0,0,9.056,13.4Zm8.311,8.681A9.042,9.042,0,1,0,4,13.042a9.042,9.042,0,0,0,9.042,9.042Z"
                                transform="translate(-4 -4)"
                                fill="#009545"
                                stroke="#009545"
                                stroke-width="0.5"
                                fill-rule="evenodd"
                            />
                        </g>
                    </g>
                </svg>
            );

        case RockClimbingTitles.some(
            (t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle
        ):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <circle
                        id="Ellipse_1764"
                        data-name="Ellipse 1764"
                        cx="18"
                        cy="18"
                        r="18"
                        fill="#1cb0bd"
                        opacity="0.1"
                    />
                    <g
                        id="Group_11119"
                        data-name="Group 11119"
                        transform="translate(12368 -8948.336)"
                    >
                        <g
                            id="Group_11117"
                            data-name="Group 11117"
                            transform="translate(-12359 8958.677)"
                        >
                            <g
                                id="Rectangle_17146"
                                data-name="Rectangle 17146"
                                transform="translate(0 10.658)"
                                fill="#cfe0e0"
                                stroke="#1cb0bd"
                                stroke-width="1"
                            >
                                <rect width="18" height="5" stroke="none" />
                                <rect
                                    x="0.5"
                                    y="0.5"
                                    width="17"
                                    height="4"
                                    fill="none"
                                />
                            </g>
                            <g
                                id="Rectangle_17145"
                                data-name="Rectangle 17145"
                                transform="translate(3 1.658)"
                                fill="#cfe0e0"
                                stroke="#1cb0bd"
                                stroke-width="1"
                            >
                                <rect width="12" height="12" stroke="none" />
                                <rect
                                    x="0.5"
                                    y="0.5"
                                    width="11"
                                    height="11"
                                    fill="none"
                                />
                            </g>
                            <g
                                id="Rectangle_17147"
                                data-name="Rectangle 17147"
                                transform="translate(0 -0.342)"
                                fill="#cfe0e0"
                                stroke="#1cb0bd"
                                stroke-width="1"
                            >
                                <rect
                                    width="18"
                                    height="3"
                                    rx="1.5"
                                    stroke="none"
                                />
                                <rect
                                    x="0.5"
                                    y="0.5"
                                    width="17"
                                    height="2"
                                    rx="1"
                                    fill="none"
                                />
                            </g>
                        </g>
                        <g
                            id="Group_11118"
                            data-name="Group 11118"
                            transform="translate(-12355.493 8961.305)"
                        >
                            <path
                                id="Polygon_2"
                                data-name="Polygon 2"
                                d="M.121,1.515a.39.39,0,0,1,.757,0h0A.39.39,0,0,1,.5,2h0a.39.39,0,0,1-.379-.485Z"
                                transform="translate(0.493 0.03)"
                                fill="#1cb0bd"
                            />
                            <path
                                id="Polygon_3"
                                data-name="Polygon 3"
                                d="M.39.571a.414.414,0,0,1,.705,0h0A.414.414,0,0,1,.743,1.2h0A.414.414,0,0,1,.39.571Z"
                                transform="translate(3.602 0) rotate(34)"
                                fill="#1cb0bd"
                            />
                            <path
                                id="Polygon_4"
                                data-name="Polygon 4"
                                d="M.39.571a.414.414,0,0,1,.705,0h0A.414.414,0,0,1,.743,1.2h0A.414.414,0,0,1,.39.571Z"
                                transform="matrix(0.259, -0.966, 0.966, 0.259, 5.442, 1.517)"
                                fill="#1cb0bd"
                            />
                            <path
                                id="Polygon_5"
                                data-name="Polygon 5"
                                d="M.39.571a.414.414,0,0,1,.705,0h0A.414.414,0,0,1,.743,1.2h0A.414.414,0,0,1,.39.571Z"
                                transform="translate(7.459 0.66) rotate(-21)"
                                fill="#1cb0bd"
                            />
                            <path
                                id="Polygon_6"
                                data-name="Polygon 6"
                                d="M.39.571a.414.414,0,0,1,.705,0h0A.414.414,0,0,1,.743,1.2h0A.414.414,0,0,1,.39.571Z"
                                transform="translate(2.995 1.828) rotate(34)"
                                fill="#1cb0bd"
                            />
                            <path
                                id="Polygon_7"
                                data-name="Polygon 7"
                                d="M.39.571a.414.414,0,0,1,.705,0h0A.414.414,0,0,1,.743,1.2h0A.414.414,0,0,1,.39.571Z"
                                transform="translate(1.3 5.991) rotate(34)"
                                fill="#1cb0bd"
                            />
                            <path
                                id="Polygon_8"
                                data-name="Polygon 8"
                                d="M.39.571a.414.414,0,0,1,.705,0h0A.414.414,0,0,1,.743,1.2h0A.414.414,0,0,1,.39.571Z"
                                transform="translate(1.3 3.249) rotate(34)"
                                fill="#1cb0bd"
                            />
                            <path
                                id="Polygon_9"
                                data-name="Polygon 9"
                                d="M.453.626a.468.468,0,0,1,.791,0h0a.468.468,0,0,1-.4.718h0a.468.468,0,0,1-.4-.718Z"
                                transform="translate(4.807 3.342) rotate(34)"
                                fill="#1cb0bd"
                            />
                            <path
                                id="Polygon_11"
                                data-name="Polygon 11"
                                d="M.437.638a.463.463,0,0,1,.788,0h0a.463.463,0,0,1-.394.707h0A.463.463,0,0,1,.437.638Z"
                                transform="translate(6.788 2.32) rotate(34)"
                                fill="#1cb0bd"
                            />
                            <path
                                id="Polygon_12"
                                data-name="Polygon 12"
                                d="M.39.571a.414.414,0,0,1,.705,0h0A.414.414,0,0,1,.743,1.2h0A.414.414,0,0,1,.39.571Z"
                                transform="translate(9.343 3.45) rotate(34)"
                                fill="#1cb0bd"
                            />
                            <path
                                id="Polygon_13"
                                data-name="Polygon 13"
                                d="M.39.571a.414.414,0,0,1,.705,0h0A.414.414,0,0,1,.743,1.2h0A.414.414,0,0,1,.39.571Z"
                                transform="translate(4.555 6.563) rotate(34)"
                                fill="#1cb0bd"
                            />
                            <path
                                id="Polygon_14"
                                data-name="Polygon 14"
                                d="M.39.571a.414.414,0,0,1,.705,0h0A.414.414,0,0,1,.743,1.2h0A.414.414,0,0,1,.39.571Z"
                                transform="translate(7.137 5.107) rotate(34)"
                                fill="#1cb0bd"
                            />
                            <path
                                id="Polygon_15"
                                data-name="Polygon 15"
                                d="M.426.623a.452.452,0,0,1,.769,0h0a.452.452,0,0,1-.385.689h0A.452.452,0,0,1,.426.623Z"
                                transform="translate(8.279 6.739) rotate(34)"
                                fill="#1cb0bd"
                            />
                            <path
                                id="Polygon_16"
                                data-name="Polygon 16"
                                d="M.39.571a.414.414,0,0,1,.705,0h0A.414.414,0,0,1,.743,1.2h0A.414.414,0,0,1,.39.571Z"
                                transform="translate(6.425 7.983) rotate(34)"
                                fill="#1cb0bd"
                            />
                            <path
                                id="Polygon_17"
                                data-name="Polygon 17"
                                d="M.39.571a.414.414,0,0,1,.705,0h0A.414.414,0,0,1,.743,1.2h0A.414.414,0,0,1,.39.571Z"
                                transform="translate(2.252 8.733) rotate(34)"
                                fill="#1cb0bd"
                            />
                        </g>
                    </g>
                </svg>
            );

        case bowlingTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <circle
                        id="Ellipse_1765"
                        data-name="Ellipse 1765"
                        cx="18"
                        cy="18"
                        r="18"
                        fill="#16519e"
                        opacity="0.1"
                    />
                    <g
                        id="_x33_9_x2C__Bowling_x2C__Bowling_Pin_x2C__Bowling_Ball_x2C__Hobbies_and_free_Time_x2C__Hobbies_and_free_Time_x2C__Arcade_x2C__Sportive_x2C__Sport_x2C_"
                        transform="translate(9 9)"
                    >
                        <g
                            id="Group_11121"
                            data-name="Group 11121"
                            transform="translate(1 1)"
                        >
                            <circle
                                id="Ellipse_1766"
                                data-name="Ellipse 1766"
                                cx="0.682"
                                cy="0.682"
                                r="0.682"
                                transform="translate(12.739 9.87)"
                                fill="none"
                                stroke="#16519e"
                                stroke-width="0.2"
                            />
                            <ellipse
                                id="Ellipse_1767"
                                data-name="Ellipse 1767"
                                cx="0.569"
                                cy="0.682"
                                rx="0.569"
                                ry="0.682"
                                transform="translate(10.237 9.87)"
                                fill="none"
                                stroke="#16519e"
                                stroke-width="0.2"
                            />
                            <ellipse
                                id="Ellipse_1768"
                                data-name="Ellipse 1768"
                                cx="0.682"
                                cy="0.569"
                                rx="0.682"
                                ry="0.569"
                                transform="translate(11.374 7.595)"
                                fill="none"
                                stroke="#16519e"
                                stroke-width="0.2"
                            />
                            <g
                                id="Group_11120"
                                data-name="Group 11120"
                                transform="translate(0 0)"
                            >
                                <path
                                    id="Path_7076"
                                    data-name="Path 7076"
                                    d="M43.315,241.449a.327.327,0,1,0-.607-.246,8.667,8.667,0,0,0,.126,7.1.327.327,0,0,0,.6-.273A8.013,8.013,0,0,1,43.315,241.449Z"
                                    transform="translate(-40.667 -233.142)"
                                    fill="#16519e"
                                    stroke="#16519e"
                                    stroke-width="0.2"
                                />
                                <path
                                    id="Path_7077"
                                    data-name="Path 7077"
                                    d="M11.933,6.172A5.745,5.745,0,0,0,7.787,7.938a12.52,12.52,0,0,0-.61-1.14,3.314,3.314,0,0,1-.262-2.9,2.126,2.126,0,1,0-3.966-.006A3.318,3.318,0,0,1,2.68,6.8a10.266,10.266,0,0,0-.52,10.358.976.976,0,0,0,.873.533h3.8a.975.975,0,0,0,.873-.532c.153-.3.293-.606.417-.914A5.76,5.76,0,1,0,11.933,6.172ZM3.789,5.583H6.073a4.026,4.026,0,0,0,.257.982h-2.8A3.988,3.988,0,0,0,3.789,5.583ZM4.933,1.655a1.47,1.47,0,0,1,1.373,2,4.083,4.083,0,0,0-.262,1.274H3.82a3.95,3.95,0,0,0-.26-1.274A1.47,1.47,0,0,1,4.933,1.655Zm2.189,15.21a.323.323,0,0,1-.29.175h-3.8a.324.324,0,0,1-.291-.177A9.6,9.6,0,0,1,3.194,7.22H6.663a10.8,10.8,0,0,1,.656,1.268,5.75,5.75,0,0,0,.3,7.255A10.452,10.452,0,0,1,7.121,16.865Zm4.812.175a5.107,5.107,0,1,1,5.107-5.107A5.112,5.112,0,0,1,11.933,17.04Z"
                                    transform="translate(-1 -1)"
                                    fill="#16519e"
                                    stroke="#16519e"
                                    stroke-width="0.2"
                                />
                                <path
                                    id="Path_7078"
                                    data-name="Path 7078"
                                    d="M203.3,206a.327.327,0,1,0-.19-.627,4.421,4.421,0,0,0-2.949,5.51.327.327,0,0,0,.627-.19A3.767,3.767,0,0,1,203.3,206Z"
                                    transform="translate(-193.461 -198.669)"
                                    fill="#16519e"
                                    stroke="#16519e"
                                    stroke-width="0.2"
                                />
                                <path
                                    id="Path_7079"
                                    data-name="Path 7079"
                                    d="M342.964,221.982a.982.982,0,1,0-.982.982A.983.983,0,0,0,342.964,221.982Zm-.982.327a.327.327,0,1,1,.327-.327A.328.328,0,0,1,341.982,222.309Z"
                                    transform="translate(-329.87 -213.798)"
                                    fill="#16519e"
                                    stroke="#16519e"
                                    stroke-width="0.2"
                                />
                                <path
                                    id="Path_7080"
                                    data-name="Path 7080"
                                    d="M301.982,291a.982.982,0,1,0,.982.982A.983.983,0,0,0,301.982,291Zm0,1.309a.327.327,0,1,1,.327-.327A.328.328,0,0,1,301.982,292.309Z"
                                    transform="translate(-291.18 -281.507)"
                                    fill="#16519e"
                                    stroke="#16519e"
                                    stroke-width="0.2"
                                />
                                <path
                                    id="Path_7081"
                                    data-name="Path 7081"
                                    d="M381.982,291a.982.982,0,1,0,.982.982A.983.983,0,0,0,381.982,291Zm0,1.309a.327.327,0,1,1,.327-.327A.328.328,0,0,1,381.982,292.309Z"
                                    transform="translate(-368.561 -281.507)"
                                    fill="#16519e"
                                    stroke="#16519e"
                                    stroke-width="0.2"
                                />
                            </g>
                        </g>
                    </g>
                </svg>
            );

        case soccerTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_11122"
                        data-name="Group 11122"
                        transform="translate(-25 -484)"
                    >
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 484)"
                            fill="red"
                            opacity="0.1"
                        />
                    </g>
                    <path
                        id="_809668_field_football_football_field_sports_stadion_icon"
                        data-name="809668_field_football_football field_sports_stadion_icon"
                        d="M12.859,0H.584A.552.552,0,0,0,0,.584V13.443a.552.552,0,0,0,.584.584H12.859a.552.552,0,0,0,.584-.584V.584A.552.552,0,0,0,12.859,0ZM1.169,4.676a2.338,2.338,0,0,1,0,4.676Zm0,8.183V9.936a2.922,2.922,0,1,0,0-5.845V1.169h5.26v11.69ZM12.274,9.352a2.338,2.338,0,1,1,0-4.676Zm0-5.26a2.922,2.922,0,1,0,0,5.845v2.922H7.014V1.169h5.26Z"
                        transform="translate(11 11)"
                        fill="red"
                    />
                </svg>
            );

        case CricketGroundTitles.some(
            (t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle
        ):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_11123"
                        data-name="Group 11123"
                        transform="translate(-25 -484)"
                    >
                        <circle
                            id="Ellipse_156"
                            data-name="Ellipse 156"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 484)"
                            fill="#e2a500"
                            opacity="0.1"
                        />
                    </g>
                    <path
                        id="_10863474_fi_br_cricket_icon"
                        data-name="10863474_fi_br_cricket_icon"
                        d="M15.877,13.9a1.985,1.985,0,1,1-1.985-1.985A1.985,1.985,0,0,1,15.877,13.9ZM13.891,3.389,11.352,5.929h0a1.443,1.443,0,0,0-.439,1.007,1.352,1.352,0,0,0,.118.539,2.348,2.348,0,0,1-.449,2.634L5.509,15.18a2.306,2.306,0,0,1-1.319.657,4.614,4.614,0,0,1-.653.046,3.515,3.515,0,0,1-2.543-1,3.667,3.667,0,0,1-.956-3.195A2.316,2.316,0,0,1,.7,10.367L5.769,5.294A2.34,2.34,0,0,1,8.4,4.844a1.6,1.6,0,0,0,.557.12,1.449,1.449,0,0,0,.993-.439l2.54-2.539L12.2,1.695A.993.993,0,1,1,13.6.29l1.985,1.985a.993.993,0,1,1-1.4,1.4ZM8.615,9.265H7.556c-.283,0-.945,0-.945-.88V7.261L2.1,11.771a.343.343,0,0,0-.1.2A1.753,1.753,0,0,0,2.4,13.481a1.75,1.75,0,0,0,1.512.393.34.34,0,0,0,.195-.1Z"
                        transform="translate(10.021 9)"
                        fill="#e2a500"
                    />
                </svg>
            );

        case badmintonCourtTitles.some(
            (t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle
        ):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <circle
                        id="Ellipse_1769"
                        data-name="Ellipse 1769"
                        cx="18"
                        cy="18"
                        r="18"
                        fill="#1cb0bd"
                        opacity="0.1"
                    />
                    <g
                        id="_3689820_badminton_olimpiade_set_shuttlecock_sport_icon"
                        data-name="3689820_badminton_olimpiade_set_shuttlecock_sport_icon"
                        transform="translate(-31.457 1.807)"
                    >
                        <path
                            id="Path_7085"
                            data-name="Path 7085"
                            d="M85.219,175.97h0a3.844,3.844,0,0,1-3.844-3.844v-2.611h7.688v2.611A3.844,3.844,0,0,1,85.219,175.97Z"
                            transform="translate(-35.709 -150.331)"
                            fill="none"
                            stroke="#1cb0bd"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-width="1"
                        />
                        <path
                            id="Path_7086"
                            data-name="Path 7086"
                            d="M53.332,19.185H45.687L42.457,9.163l.068-.077a2.92,2.92,0,0,1,4.336.15l.343.471.354-.5a2.521,2.521,0,0,1,3.9,0l.354.5.343-.471a2.92,2.92,0,0,1,4.336-.15l.068.077Z"
                            fill="none"
                            stroke="#1cb0bd"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-width="1"
                        />
                        <line
                            id="Line_1319"
                            data-name="Line 1319"
                            x2="7.915"
                            transform="translate(45.635 21.285)"
                            fill="none"
                            stroke="#1cb0bd"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-width="1"
                        />
                        <line
                            id="Line_1320"
                            data-name="Line 1320"
                            x2="1.085"
                            y2="11.47"
                            transform="translate(47.203 10.04)"
                            fill="none"
                            stroke="#1cb0bd"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-width="1"
                        />
                        <line
                            id="Line_1321"
                            data-name="Line 1321"
                            y1="11.47"
                            x2="1.085"
                            transform="translate(50.73 10.04)"
                            fill="none"
                            stroke="#1cb0bd"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-width="1"
                        />
                        <path
                            id="Path_7087"
                            data-name="Path 7087"
                            d="M56.193,76.461l2.076.658,1.9-.658,1.948.658,1.948-.658,1.9.658,2.076-.658"
                            transform="translate(-12.604 -63.319)"
                            fill="none"
                            stroke="#1cb0bd"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-width="1"
                        />
                        <line
                            id="Line_1322"
                            data-name="Line 1322"
                            x1="1.085"
                            y2="11.47"
                            transform="translate(50.73 10.04)"
                            fill="none"
                            stroke="#1cb0bd"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-width="1"
                        />
                    </g>
                </svg>
            );

        case skatingRingTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <circle
                        id="Ellipse_1678"
                        data-name="Ellipse 1678"
                        cx="18"
                        cy="18"
                        r="18"
                        fill="red"
                        opacity="0.1"
                    />
                    <g id="skate-23" transform="translate(-54.486 -54.96)">
                        <path
                            id="Path_6324"
                            data-name="Path 6324"
                            d="M80.869,82.012A5.465,5.465,0,0,1,77,72.68l7.43-7.43a5.47,5.47,0,0,1,7.735,7.735l-7.43,7.428A5.453,5.453,0,0,1,80.869,82.012ZM88.3,64.358a4.747,4.747,0,0,0-3.366,1.391L77.5,73.181a4.76,4.76,0,0,0,6.731,6.731l7.43-7.43A4.759,4.759,0,0,0,88.3,64.358Z"
                            transform="translate(-11.971 0)"
                            fill="red"
                        />
                        <path
                            id="Path_6325"
                            data-name="Path 6325"
                            d="M731.923,426.927l-1.578-1.578a.067.067,0,0,1,0-.1l2.809-2.809a.067.067,0,0,1,.1,0l1.578,1.578a.067.067,0,0,1,0,.1l-2.809,2.809A.067.067,0,0,1,731.923,426.927Z"
                            transform="translate(-653.281 -351.317)"
                            fill="red"
                        />
                        <path
                            id="Path_6326"
                            data-name="Path 6326"
                            d="M725.263,420.482a.931.931,0,0,1-.659-.272l-.856-.856a.932.932,0,0,1,0-1.318l2.087-2.087a.932.932,0,0,1,1.318,0l.857.856a.934.934,0,0,1,0,1.318l-2.087,2.087A.919.919,0,0,1,725.263,420.482Zm1.231-4.1a.223.223,0,0,0-.158.064l-2.087,2.087a.221.221,0,0,0,0,.314l.857.856a.229.229,0,0,0,.314,0l2.087-2.087a.223.223,0,0,0,0-.314l-.856-.857A.215.215,0,0,0,726.494,416.384Z"
                            transform="translate(-646.573 -344.707)"
                            fill="red"
                        />
                        <path
                            id="Path_6327"
                            data-name="Path 6327"
                            d="M419.523,739.427l-1.578-1.578a.066.066,0,0,1,0-.1l2.809-2.809a.067.067,0,0,1,.1,0l1.578,1.578a.066.066,0,0,1,0,.1l-2.809,2.809A.07.07,0,0,1,419.523,739.427Z"
                            transform="translate(-347.375 -657.32)"
                            fill="red"
                        />
                        <path
                            id="Path_6328"
                            data-name="Path 6328"
                            d="M412.863,732.906a.93.93,0,0,1-.659-.272l-.856-.856a.932.932,0,0,1,0-1.318l2.087-2.087a.934.934,0,0,1,1.318,0l.856.857a.932.932,0,0,1,0,1.318l-2.087,2.087A.921.921,0,0,1,412.863,732.906Zm-.158-.773a.221.221,0,0,0,.314,0l2.087-2.087a.221.221,0,0,0,0-.314l-.857-.857a.229.229,0,0,0-.314,0l-2.087,2.085a.221.221,0,0,0,0,.314Z"
                            transform="translate(-340.668 -650.637)"
                            fill="red"
                        />
                        <path
                            id="Path_6329"
                            data-name="Path 6329"
                            d="M384.023,79.125l-1.578-1.578a.067.067,0,0,1,0-.1l2.809-2.806a.067.067,0,0,1,.1,0l1.578,1.578a.067.067,0,0,1,0,.1l-2.809,2.806A.066.066,0,0,1,384.023,79.125Z"
                            transform="translate(-312.613 -10.747)"
                            fill="red"
                        />
                        <path
                            id="Path_6330"
                            data-name="Path 6330"
                            d="M377.363,72.484a.931.931,0,0,1-.659-.272l-.856-.856a.932.932,0,0,1,0-1.318l2.087-2.089a.932.932,0,0,1,1.318,0l.856.856a.933.933,0,0,1,0,1.318l-2.087,2.089A.931.931,0,0,1,377.363,72.484Zm1.231-4.1a.223.223,0,0,0-.158.064l-2.087,2.087a.221.221,0,0,0,0,.314l.856.856a.229.229,0,0,0,.314,0l2.087-2.087a.223.223,0,0,0,0-.314l-.857-.856A.219.219,0,0,0,378.594,68.386Z"
                            transform="translate(-305.906 -3.941)"
                            fill="red"
                        />
                        <path
                            id="Path_6331"
                            data-name="Path 6331"
                            d="M71.623,391.525l-1.578-1.576a.067.067,0,0,1,0-.1l2.806-2.809a.067.067,0,0,1,.1,0l1.578,1.578a.067.067,0,0,1,0,.1l-2.806,2.806A.066.066,0,0,1,71.623,391.525Z"
                            transform="translate(-6.708 -316.652)"
                            fill="red"
                        />
                        <path
                            id="Path_6332"
                            data-name="Path 6332"
                            d="M64.963,203.73a.93.93,0,0,1-.659-.272l-.856-.856a.932.932,0,0,1,0-1.318l2.087-2.087a.933.933,0,0,1,1.318,0l.856.856a.932.932,0,0,1,0,1.318l-2.087,2.087A.937.937,0,0,1,64.963,203.73Zm1.229-4.1a.22.22,0,0,0-.156.064l-2.087,2.087a.221.221,0,0,0,0,.314l.856.856a.221.221,0,0,0,.314,0l2.087-2.087a.221.221,0,0,0,0-.314l-.856-.856A.222.222,0,0,0,66.192,199.632Zm11.646,2.187a.359.359,0,0,1-.252-.1l-5.363-5.363a.354.354,0,1,1,.5-.5l5.363,5.363a.353.353,0,0,1,0,.5A.347.347,0,0,1,77.838,201.819Zm1-.975a.359.359,0,0,1-.252-.1l-1.73-1.73a.354.354,0,0,1-.1-.252.357.357,0,0,1,.1-.252.824.824,0,0,0,.229-.565.787.787,0,0,0-.222-.578.839.839,0,0,0-1.143.006.353.353,0,0,1-.5,0l-1.69-1.69a.354.354,0,0,1,.5-.5l1.47,1.47a1.544,1.544,0,0,1,1.867.214,1.489,1.489,0,0,1,.43,1.093,1.593,1.593,0,0,1-.216.771l1.511,1.511a.353.353,0,0,1,0,.5A.359.359,0,0,1,78.842,200.844Z"
                            transform="translate(0 -128.693)"
                            fill="red"
                        />
                        <path
                            id="Path_6333"
                            data-name="Path 6333"
                            d="M186.694,512.946a.359.359,0,0,1-.252-.1l-5.363-5.363a.354.354,0,1,1,.5-.5l5.363,5.363a.353.353,0,0,1,0,.5A.339.339,0,0,1,186.694,512.946Zm1.033-1a.359.359,0,0,1-.252-.1l-1.73-1.73a.353.353,0,0,1,0-.5.8.8,0,1,0-1.137-1.137.353.353,0,0,1-.5,0l-1.69-1.69a.354.354,0,1,1,.5-.5l1.47,1.47a1.511,1.511,0,0,1,2.081,2.081l1.509,1.509a.353.353,0,0,1,0,.5A.363.363,0,0,1,187.728,511.942Z"
                            transform="translate(-115.351 -433.326)"
                            fill="red"
                        />
                    </g>
                </svg>
            );

        case ShootingTitles.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <circle
                        id="Ellipse_1770"
                        data-name="Ellipse 1770"
                        cx="18"
                        cy="18"
                        r="18"
                        fill="#16519e"
                        opacity="0.1"
                    />
                    <g
                        id="_753892_hunting_gun_shooting_target_weapon_icon"
                        data-name="753892_hunting_gun_shooting_target_weapon_icon"
                        transform="translate(9.063 9.063)"
                    >
                        <path
                            id="Path_7088"
                            data-name="Path 7088"
                            d="M36.436,8.184A6.229,6.229,0,0,1,39.525,9.92a5.892,5.892,0,0,1,1.6,2.777.486.486,0,0,0,.586.368c.117-.02.469-.2.264-.8a7.043,7.043,0,0,0-5.16-4.922c-.417-.078-.57.059-.637.249A.454.454,0,0,0,36.436,8.184Z"
                            transform="translate(-25.66 -5.23)"
                            fill="#16519e"
                        />
                        <path
                            id="Path_7089"
                            data-name="Path 7089"
                            d="M11.694,8.184A6.226,6.226,0,0,0,8.606,9.92,5.892,5.892,0,0,0,7,12.7a.486.486,0,0,1-.586.368c-.117-.02-.47-.2-.265-.8a7.042,7.042,0,0,1,5.16-4.922c.417-.078.57.059.636.249A.454.454,0,0,1,11.694,8.184Z"
                            transform="translate(-4.361 -5.23)"
                            fill="#16519e"
                        />
                        <path
                            id="Path_7090"
                            data-name="Path 7090"
                            d="M11.679,42.465a6.227,6.227,0,0,1-3.1-1.723,5.9,5.9,0,0,1-1.613-2.77.486.486,0,0,0-.587-.365c-.117.02-.469.2-.261.8a7.041,7.041,0,0,0,5.18,4.9c.417.077.57-.061.635-.252A.454.454,0,0,0,11.679,42.465Z"
                            transform="translate(-4.337 -26.683)"
                            fill="#16519e"
                        />
                        <path
                            id="Path_7091"
                            data-name="Path 7091"
                            d="M36.468,42.437a6.224,6.224,0,0,0,3.081-1.749A5.893,5.893,0,0,0,41.139,37.9a.487.487,0,0,1,.585-.37c.117.019.469.193.267.8a7.047,7.047,0,0,1-5.14,4.943c-.416.08-.57-.056-.637-.246A.454.454,0,0,1,36.468,42.437Z"
                            transform="translate(-25.685 -26.632)"
                            fill="#16519e"
                        />
                        <path
                            id="Path_7092"
                            data-name="Path 7092"
                            d="M37.037,18.7A3.115,3.115,0,0,1,38.56,20.25a.477.477,0,0,0,.666.22.455.455,0,0,0,.2-.57,4.156,4.156,0,0,0-1.985-2.037.5.5,0,0,0-.513.183A.521.521,0,0,0,37.037,18.7Z"
                            transform="translate(-26.158 -12.686)"
                            fill="#16519e"
                        />
                        <path
                            id="Path_7093"
                            data-name="Path 7093"
                            d="M19.374,18.7a3.115,3.115,0,0,0-1.524,1.545.477.477,0,0,1-.667.22.455.455,0,0,1-.2-.57,4.156,4.156,0,0,1,1.985-2.037.5.5,0,0,1,.513.183A.522.522,0,0,1,19.374,18.7Z"
                            transform="translate(-12.056 -12.686)"
                            fill="#16519e"
                        />
                        <path
                            id="Path_7094"
                            data-name="Path 7094"
                            d="M19.374,38.687a3.115,3.115,0,0,1-1.524-1.545.477.477,0,0,0-.667-.22.455.455,0,0,0-.2.571,4.161,4.161,0,0,0,1.985,2.036.5.5,0,0,0,.513-.183A.522.522,0,0,0,19.374,38.687Z"
                            transform="translate(-12.056 -26.162)"
                            fill="#16519e"
                        />
                        <path
                            id="Path_7095"
                            data-name="Path 7095"
                            d="M37.037,38.686a3.115,3.115,0,0,0,1.524-1.546.477.477,0,0,1,.666-.219.456.456,0,0,1,.2.571,4.156,4.156,0,0,1-1.985,2.037.5.5,0,0,1-.513-.183A.522.522,0,0,1,37.037,38.686Z"
                            transform="translate(-26.158 -26.161)"
                            fill="#16519e"
                        />
                        <path
                            id="Path_7096"
                            data-name="Path 7096"
                            d="M18.159,8.68H9.649V.406A.469.469,0,0,0,9.18-.063H8.916a.469.469,0,0,0-.469.469V8.679H.406a.469.469,0,0,0-.469.469v.263a.469.469,0,0,0,.469.469H8.447v8.278a.469.469,0,0,0,.469.469H9.18a.469.469,0,0,0,.469-.469V9.881h8.51a.469.469,0,0,0,.469-.469V9.148A.468.468,0,0,0,18.159,8.68Z"
                            transform="translate(0 0)"
                            fill="#16519e"
                        />
                    </g>
                </svg>
            );
        case SeatingAreas.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                    <g id="Seating_Areas" data-name="Seating Areas" transform="translate(-25 -1007.319)">
                        <circle id="Ellipse_378" data-name="Ellipse 378" cx="18" cy="18" r="18" transform="translate(25 1007.319)" fill="#4d78eb" opacity="0.1" />
                        <g id="armchair" transform="translate(16 1015.319)">
                            <g id="Group_3347" data-name="Group 3347" transform="translate(18)">
                                <path id="Path_6105" data-name="Path 6105" d="M33.577,6.479V2.836A2.633,2.633,0,0,0,30.74,0H22.581a2.633,2.633,0,0,0-2.836,2.836V6.479A2.318,2.318,0,0,0,18,8.726v5.847a2.281,2.281,0,0,0,2.291,2.465v1.483a.782.782,0,0,0,.785.785h.807a.782.782,0,0,0,.785-.785V17.038h8.006v1.483a.782.782,0,0,0,.785.785h.807a.782.782,0,0,0,.785-.785V17.038a2.286,2.286,0,0,0,2.291-2.465V8.7A2.387,2.387,0,0,0,33.577,6.479ZM20.531,2.836A1.875,1.875,0,0,1,22.581.764H30.74a1.857,1.857,0,0,1,2.051,2.051V6.392A2.325,2.325,0,0,0,30.675,8.7V9.25H22.647V8.7a2.325,2.325,0,0,0-2.116-2.312V2.836Zm10.123,7.2V12.74H22.647V10.035Zm-8.77,8.486h-.807V17.038h.807Zm10.363,0h-.807V17.038h.807Zm2.312-3.949h-.022a1.524,1.524,0,0,1-1.7,1.7H20.487a1.524,1.524,0,0,1-1.7-1.7V8.7a1.549,1.549,0,0,1,3.1,0v4.429a.391.391,0,0,0,.393.393h8.792a.391.391,0,0,0,.393-.393V8.7a1.549,1.549,0,1,1,3.1,0Z" transform="translate(-18)" fill="#4d78eb" stroke="#4d78eb" stroke-width="0.4" />
                            </g>
                        </g>
                    </g>
                </svg>
            );

        case SeniorCitizenSeatingArea.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                    <g id="Senior_Citizen_Seating_Area" data-name="Senior Citizen Seating Area" transform="translate(-25 -487.361)">
                        <g id="Group_3351" data-name="Group 3351" transform="translate(0 -519.958)">
                            <circle id="Ellipse_378" data-name="Ellipse 378" cx="18" cy="18" r="18" transform="translate(25 1007.319)" fill="#dcedeb" />
                        </g>
                        <g id="_x37_2" transform="translate(29.332 493.052)">
                            <path id="Path_6106" data-name="Path 6106" d="M19.727,19.314a.417.417,0,1,0-.418-.417A.431.431,0,0,0,19.727,19.314Z" transform="translate(-8.507 -9.727)" fill="#14897b" />
                            <path id="Path_6107" data-name="Path 6107" d="M19.727,23.114a.417.417,0,1,0-.418-.417A.431.431,0,0,0,19.727,23.114Z" transform="translate(-8.507 -12.013)" fill="#14897b" />
                            <path id="Path_6108" data-name="Path 6108" d="M19.727,26.914a.417.417,0,1,0-.418-.417A.431.431,0,0,0,19.727,26.914Z" transform="translate(-8.507 -14.299)" fill="#14897b" />
                            <path id="Path_6109" data-name="Path 6109" d="M17.163,6.479a2.085,2.085,0,1,0-2.081-2.085A2.087,2.087,0,0,0,17.163,6.479Zm0-3.373A1.288,1.288,0,1,1,15.88,4.394,1.29,1.29,0,0,1,17.163,3.106Z" transform="translate(-5.964)" fill="#14897b" />
                            <path id="Path_6110" data-name="Path 6110" d="M5.559,17.647a1.323,1.323,0,0,0-.117,1.746v9.1a.4.4,0,1,0,.8,0V19.9a1.335,1.335,0,0,0,1.207-.363l1.286-1.284v8.705a1.625,1.625,0,0,0,1.623,1.623h1.73a1.625,1.625,0,0,0,1.623-1.623V24.464h.848a.122.122,0,0,1,.122.122v2.763a1.413,1.413,0,0,0,1.411,1.411h1.093a1.413,1.413,0,0,0,1.411-1.411V24.586a.122.122,0,0,1,.122-.122h.837a.8.8,0,0,0,.774-1l-1.25-4.739.814.813A1.324,1.324,0,0,0,21.1,19.9v8.595a.4.4,0,1,0,.8,0V19.384a1.323,1.323,0,0,0-.124-1.737l-2.64-2.64a1.894,1.894,0,0,0-1.348-.558h-2.33a1.774,1.774,0,0,0-.971.288,1.749,1.749,0,0,0-.96-.288H9.547a1.894,1.894,0,0,0-1.348.558ZM17.8,24.586v2.763a.615.615,0,0,1-.614.614h-.148v-1.67a.4.4,0,0,0-.8,0v1.67h-.148a.615.615,0,0,1-.614-.614V24.586a.9.9,0,0,0-.012-.122h2.347A.9.9,0,0,0,17.8,24.586Zm-.009-9.34a1.1,1.1,0,0,1,.785.325l2.64,2.641a.538.538,0,0,1-.76.761L18.7,17.221a.38.38,0,0,0-.063-.042.4.4,0,0,0-.7.344l1.617,6.144H13.708V22.225h.063a1.52,1.52,0,0,0,1.518-1.518v-4.5a1.74,1.74,0,0,0-.241-.872.981.981,0,0,1,.41-.092Zm-8.241,0h3.98a.966.966,0,0,1,.965.964v4.5a.722.722,0,0,1-.721.721h-.063V19.285a.4.4,0,1,0-.8,0v7.671a.827.827,0,0,1-.826.826h-.466V24.364a.4.4,0,1,0-.8,0v3.418h-.467a.827.827,0,0,1-.826-.826V17.284a.4.4,0,0,0-.4-.4.391.391,0,0,0-.316.168.374.374,0,0,0-.035.023l-1.9,1.895a.538.538,0,0,1-.76,0h0a.538.538,0,0,1,0-.761l2.64-2.64A1.1,1.1,0,0,1,9.547,15.245Z" transform="translate(0 -7.302)" fill="#14897b" />
                            <path id="Path_6111" data-name="Path 6111" d="M32.887,4.394A2.083,2.083,0,1,0,30.8,6.479,2.087,2.087,0,0,0,32.887,4.394Zm-3.369,0A1.286,1.286,0,1,1,30.8,5.682,1.287,1.287,0,0,1,29.518,4.394Z" transform="translate(-14.168)" fill="#14897b" />
                        </g>
                    </g>
                </svg>
            );
        case BanquetHall.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                    <g id="Banwuet_Hall" data-name="Banwuet Hall" transform="translate(-25 -487.639)">
                        <g id="Group_3351" data-name="Group 3351" transform="translate(0 -519.681)">
                            <circle id="Ellipse_378" data-name="Ellipse 378" cx="18" cy="18" r="18" transform="translate(25 1007.319)" fill="#d9e8fc" />
                        </g>
                        <path id="theater" d="M19.132,6.225v7.121a.445.445,0,1,1-.89,0V6.225A1.335,1.335,0,0,0,16.907,4.89H6.225A1.335,1.335,0,0,0,4.89,6.225v7.121a.445.445,0,0,1-.89,0V6.225A2.225,2.225,0,0,1,6.225,4H16.907a2.225,2.225,0,0,1,2.225,2.225Zm-2.225,9.346a.445.445,0,0,0,.445-.445v-.89A1.335,1.335,0,0,0,16.016,12.9h-1.78a1.324,1.324,0,0,0-.89.347,1.324,1.324,0,0,0-.89-.347h-1.78a1.324,1.324,0,0,0-.89.347A1.324,1.324,0,0,0,8.9,12.9H7.115A1.335,1.335,0,0,0,5.78,14.236v.89a.445.445,0,1,0,.89,0v-.89a.445.445,0,0,1,.445-.445H8.9a.445.445,0,0,1,.445.445v.89a.445.445,0,1,0,.89,0v-.89a.445.445,0,0,1,.445-.445h1.78a.445.445,0,0,1,.445.445v.89a.445.445,0,0,0,.89,0v-.89a.445.445,0,0,1,.445-.445h1.78a.445.445,0,0,1,.445.445v.89A.445.445,0,0,0,16.907,15.571Zm.89.89h-1.78a1.324,1.324,0,0,0-.89.347,1.324,1.324,0,0,0-.89-.347h-1.78a1.324,1.324,0,0,0-.89.347,1.324,1.324,0,0,0-.89-.347H8.9a1.324,1.324,0,0,0-.89.347,1.324,1.324,0,0,0-.89-.347H5.335A1.335,1.335,0,0,0,4,17.8v.89a.445.445,0,0,0,.89,0V17.8a.445.445,0,0,1,.445-.445h1.78a.445.445,0,0,1,.445.445v.89a.445.445,0,0,0,.89,0V17.8a.445.445,0,0,1,.445-.445h1.78a.445.445,0,0,1,.445.445v.89a.445.445,0,0,0,.89,0V17.8a.445.445,0,0,1,.445-.445h1.78a.445.445,0,0,1,.445.445v.89a.445.445,0,0,0,.89,0V17.8a.445.445,0,0,1,.445-.445H17.8a.445.445,0,0,1,.445.445v.89a.445.445,0,0,0,.89,0V17.8A1.335,1.335,0,0,0,17.8,16.462Z" transform="translate(31 493.639)" fill="#4d78eb" stroke="#4d78eb" stroke-width="0.3" />
                    </g>
                </svg>
            );

        case KidsPlayArea.some((t) => t.toLowerCase().trim().replace(/\s+/g, ' ') === normalizedTitle):
            return (
                <svg xmlns="http://www.w3.org/2000/svg"  width="36" height="36" viewBox="0 0 36 36">
                    {/* <defs>
                        <clipPath id="clip-path">
                            <path id="path1308" d="M0-682.665H20v20H0Z" transform="translate(0 682.665)" fill="#ec1c24" />
                        </clipPath>
                    </defs> */}
                    <g id="Kids_Play_Area" data-name="Kids Play Area" transform="translate(-25 -422)">
                        <g id="Group_3349" data-name="Group 3349" transform="translate(0 -585.319)">
                            <circle id="Ellipse_378" data-name="Ellipse 378" cx="18" cy="18" r="18" transform="translate(25 1007.319)" fill="#ffe5e5" />
                        </g>
                        <g id="g1302" transform="translate(33 1112.665)">
                            <g id="g1304" transform="translate(0 -682.665)">
                                <g id="g1306" clip-path="url(#clip-path)">
                                    <g id="g1312" transform="translate(11.02 6.56)">
                                        <path id="path1314" d="M0-235.388l.979,5.2H8.687L6.373-242.493H4.084" transform="translate(0 242.493)" fill="none" stroke="#ec1c24" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1" />
                                    </g>
                                    <g id="g1316" transform="translate(0.293 6.56)">
                                        <path id="path1318" d="M-293.035-343.874l-1.109,1.929h-7.736l7.075-12.307h6.433" transform="translate(301.879 354.252)" fill="none" stroke="#ec1c24" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1" />
                                    </g>
                                </g>
                            </g>
                            <g id="g1320" transform="translate(9.721 -676.105)">
                                <path id="path1322" d="M-178.363,0l-5.383,9.363" transform="translate(183.746)" fill="none" stroke="#ec1c24" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1" />
                            </g>
                            <g id="g1324" transform="translate(0 -682.665)">
                                <g id="g1326" clip-path="url(#clip-path)">
                                    <g id="g1332" transform="translate(8.029 4.295)">
                                        <path id="path1334" d="M-234.431-75.055V-77.32l-7.075,12.307v2.265" transform="translate(241.506 77.32)" fill="none" stroke="#ec1c24" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1" />
                                    </g>
                                    <g id="g1336" transform="translate(0.293 4.295)">
                                        <path id="path1338" d="M-234.427-75.049v-2.265L-241.5-65.007v2.265Z" transform="translate(241.502 77.314)" fill="none" stroke="#ec1c24" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1" />
                                    </g>
                                    <g id="g1340" transform="translate(15.104 1.133)">
                                        <path id="path1342" d="M-75.818-179.818V-184.1a1.144,1.144,0,0,0-1.144-1.144,1.144,1.144,0,0,0-1.144,1.144v2.018" transform="translate(78.106 185.245)" fill="none" stroke="#ec1c24" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1" />
                                    </g>
                                    <g id="g1344" transform="translate(7.368 1.133)">
                                        <path id="path1346" d="M0-104.771v-2.018a1.14,1.14,0,0,1,.335-.809,1.14,1.14,0,0,1,.809-.335,1.144,1.144,0,0,1,1.144,1.144v.907" transform="translate(0 107.933)" fill="none" stroke="#ec1c24" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1" />
                                    </g>
                                    <g id="g1348" transform="translate(9.657 4.356)">
                                        <path id="path1350" d="M0-73.023v-2.2" transform="translate(0 75.226)" fill="none" stroke="#ec1c24" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1" />
                                    </g>
                                    <g id="g1352" transform="translate(13.307 9.685)">
                                        <path id="path1354" d="M-154.807,0h-4.672" transform="translate(159.48 0)" fill="none" stroke="#ec1c24" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1" />
                                    </g>
                                    <g id="g1356" transform="translate(11.486 12.853)">
                                        <path id="path1358" d="M-234.91,0H-242" transform="translate(241.999)" fill="none" stroke="#ec1c24" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1" />
                                    </g>
                                    <g id="g1360" transform="translate(11.463 16.021)">
                                        <path id="path1362" d="M-255.424,0h-7.709" transform="translate(263.133)" fill="none" stroke="#ec1c24" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1" />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>

            );

        default:
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="36"
                    height="36"
                    viewBox="0 0 36 36"
                >
                    <g
                        id="Group_10519"
                        data-name="Group 10519"
                        transform="translate(-25 -1429)"
                    >
                        <circle
                            id="Ellipse_378"
                            data-name="Ellipse 378"
                            cx="18"
                            cy="18"
                            r="18"
                            transform="translate(25 1429)"
                            fill="#7700ed"
                            opacity="0.1"
                        />
                        <g id="Group_929" data-name="Group 929">
                            <g
                                id="Rectangle_1056"
                                data-name="Rectangle 1056"
                                transform="translate(34 1440)"
                                fill="none"
                                stroke="#7700ed"
                                stroke-width="1.2"
                            >
                                <rect
                                    width="7"
                                    height="7"
                                    rx="1"
                                    stroke="none"
                                />
                                <rect
                                    x="0.6"
                                    y="0.6"
                                    width="5.8"
                                    height="5.8"
                                    rx="0.4"
                                    fill="none"
                                />
                            </g>
                            <g
                                id="Rectangle_1057"
                                data-name="Rectangle 1057"
                                transform="translate(47.5 1438.55) rotate(45)"
                                fill="none"
                                stroke="#7700ed"
                                stroke-width="1.2"
                            >
                                <rect
                                    width="7"
                                    height="7"
                                    rx="1"
                                    stroke="none"
                                />
                                <rect
                                    x="0.6"
                                    y="0.6"
                                    width="5.8"
                                    height="5.8"
                                    rx="0.4"
                                    fill="none"
                                />
                            </g>
                            <g
                                id="Rectangle_1058"
                                data-name="Rectangle 1058"
                                transform="translate(34 1450)"
                                fill="none"
                                stroke="#7700ed"
                                stroke-width="1.2"
                            >
                                <rect
                                    width="7"
                                    height="7"
                                    rx="1"
                                    stroke="none"
                                />
                                <rect
                                    x="0.6"
                                    y="0.6"
                                    width="5.8"
                                    height="5.8"
                                    rx="0.4"
                                    fill="none"
                                />
                            </g>
                            <g
                                id="Rectangle_1059"
                                data-name="Rectangle 1059"
                                transform="translate(44 1450)"
                                fill="none"
                                stroke="#7700ed"
                                stroke-width="1.2"
                            >
                                <rect
                                    width="7"
                                    height="7"
                                    rx="1"
                                    stroke="none"
                                />
                                <rect
                                    x="0.6"
                                    y="0.6"
                                    width="5.8"
                                    height="5.8"
                                    rx="0.4"
                                    fill="none"
                                />
                            </g>
                        </g>
                    </g>
                </svg>
            );
    }
};

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        padding: '16px',
        marginTop: '0px',
        borderRadius: '0px',
        color: 'rgba(0, 0, 0, 0.87)',
        //   boxShadow: theme.shadows[1],
        fontSize: 12
    }
}));

export default function AmenityAccordianNew({ projectAmenities }) {
    const [active, setActive] = useState(-1);
    const config = getConfig();
    const handleClick = (value) => {
        if (active === value) setActive(-1);
        else setActive(value);
    };

    console.log("projectAmenities", projectAmenities);
    // const projects = [
    //     { title: 'Gym' },
    //     { title: 'Swimming Pool' },
    //     { title: 'Tennis Court' },
    //     { title: 'Infinity Pool' },
    //     { title: 'Basketball Court' },
    //     { title: 'Badminton Court' },
    //     { title: 'Spa' },
    //     { title: 'Squash Court' },
    //     { title: 'Skating Ring' },
    //     { title: 'Shooting Range' },
    //     { title: 'Private Cinema' },
    //     { title: 'Gourmet Restaurant' },
    //     { title: 'Golf Course' },
    //     { title: 'Sports Facilities' },
    //     { title: 'Art Gallery' },
    //     { title: 'Buisness Center' },
    //     { title: 'Helipad' },
    //     { title: 'Concierge Services' },
    //     { title: 'Smart Home Technology' },
    //     { title: 'Pet Spa and Grooming Salon' },
    //     { title: 'Sky Lounge' },
    //     { title: 'Library and Reading Room' },
    //     { title: 'Music Room' },
    //     { title: 'Outdoor Amphitheater' },
    //     { title: 'Miniature Golf Course' },
    //     { title: 'Equestrian Facilities' },
    //     { title: 'Observatory Deck' },
    //     { title: 'Zen Garden' },
    //     { title: 'Jogging Track' },
    //     { title: 'Meditation Room' },
    //     { title: 'Basketball Court' },
    //     { title: 'Rock Climbing Wall' },
    //     { title: 'Bowling Alley' },
    //     { title: 'Soccer Field' },
    //     { title: 'Cricket Field' }
    // ];
    return (
        <div className="grid md:grid-cols-2 xl:grid-cols-3 mb-8 gap-x-3 gap-y-3">
            {projectAmenities.map((a, index) => (
                <div
                    key={index}
                    // onClick={() => handleClick(a.title)}
                    // onMouseOver={() => setActive(a.title)}
                    // onMouseLeave={() => setActive(-1)}
                    className={`relative ${config?.darkMode? 'border-[1px]' :'border-2'} border-gray-200 rounded-lg`}
                >
                    <div
                        key={a.title}
                        id={a.title}
                        className={
                            // (active === a.title ? 'bg-white' : '') +
                            ` ${config.fontBody} flex px-4 py-2 w-full`
                        }
                    >
                        <div>{getAmenityIcon(a.title)}</div>
                        <p
                            className={`font-medium text-left ml-4 my-auto text-md `}
                        >
                            {a.title}
                        </p>
                    </div>
                    {/* <div
                        className={
                            ((index + 1) % 2 == 0 ? 'md:right-0 ' : '') +
                            // (active === a.title && !!a?.description ? ' show ' : ' hidden ') +
                            (propertyBackgroundColorWithOverlay
                                ? propertyBackgroundColorWithOverlay +
                                ' shadow-lg'
                                : 'bg-white') +
                            ' w-[100%] min-h-[100%] md:w-[200%] absolute z-10'
                        }
                    >
                        <p className={`px-4 py-2 ${fontDetails.fontBody}`}>{a.description}</p>
                    </div> */}
                </div>
            ))}
        </div>
    );
}
